/**
 * translations.js — Diccionario central de traducciones para StarTip
 *
 * REGLAS DE PROTECCIÓN:
 *  • "STARTIP" nunca se traduce. Usar siempre la variable {{STARTIP}} o hardcode "STARTIP".
 *  • Los nombres de las modelos nunca se traducen (vienen de la API, no de este dict).
 *  • La marca aparece siempre como "STARTIP" sin importar el idioma.
 */

const translations = {

  /* ──────────────────────────────── ESPAÑOL (default) ───────────────────── */
  es: {
    translation: {
      STARTIP: "STARTIP",
      /* Loading */
      loading: "CARGANDO...",
      /* Age Gate */
      ageGate: {
        title: "Contenido para adultos",
        subtitle: "Este sitio contiene contenido exclusivo para adultos",
        confirm: "SOY MAYOR DE 18",
        deny: "Soy menor de edad",
        warning: "Debes ser mayor de edad para acceder.",
        legal: "La confirmación de mayoría de edad es responsabilidad exclusiva del usuario. STARTIP no asume ninguna responsabilidad por declaraciones falsas.",
      },
      /* Header */
      header: {
        login: "Iniciar sesión",
        logout: "Cerrar sesión",
        myPanel: "Mi Panel",
        myServices: "Mis servicios",
        chatAdmin: "Chat admin",
        admin: "Admin",
      },
      /* Hero */
      hero: {
        title: "Haz brillar a quien",
        titleHighlight: "admiras",
        howItWorks: "¿Cómo funcionamos?",
        promotions: "Promociones",
        privacyTitle: "El arte de vender, pagar y cobrar con mayor privacidad",
        privacyText: "En nuestra plataforma, puedes recibir y realizar pagos con un nombre artístico o alias, sin mostrar tu identidad real.\n\nNo necesitas compartir con el comprador, tu IBAN ni tu cuenta de PayPal personal, evitando exponer datos privados y sensibles.\n\nTambién cuidamos la privacidad de quienes pagan a un vendedor, permitiendo que su perfil también pueda contener un alias que no corresponda con su nombre real tras una compra.\n\nNuestro compromiso es facilitar que cuando vendes y compras enlaces externos, pueda seguir existiendo el anonimato y la confidencialidad por ambas partes.",
        searchPlaceholder: "Buscar modelo",
      },
      /* Live */
      live: {
        liveNow: "EN DIRECTO AHORA",
        badge: "EN DIRECTO",
        noLive: "Ninguna creadora está en directo en este momento.",
        showAll: "Ver todas las creadoras",
      },
      /* Filters */
      filters: {
        label: "Filtros",
        clearAll: "Limpiar todo",
        gender: "Sexo",
        all: "Todos",
        women: "Mujeres",
        men: "Hombres",
        socialNetworks: "Redes Sociales",
        webcamLive: "Webcam en directo",
      },
      /* Model cards */
      cards: {
        updated: "Actualizado",
        noModels: "No hay modelos disponibles aun.",
        noResults: 'No se encontraron modelos para "{{search}}"',
      },
      /* Pagination */
      pagination: {
        previous: "ANTERIOR",
        next: "SIGUIENTE",
      },
      /* Footer */
      footer: {
        legal: "Aviso legal",
        privacy: "Política de privacidad",
        cookies: "Política de cookies",
        contact: "Contacto",
      },
      /* Chat */
      chat: {
        title: "Chat con admin",
        placeholder: "Escribe tu mensaje...",
        send: "Enviar",
        noMessages: "Aún no hay mensajes. ¡Escríbenos!",
      },
      /* Login / Register */
      auth: {
        login: "Iniciar sesión",
        register: "Crear cuenta",
        email: "Email",
        password: "Contraseña",
        name: "Nombre",
        alreadyHaveAccount: "¿Ya tienes cuenta? Inicia sesión",
        noAccount: "¿No tienes cuenta? Regístrate",
        submitLogin: "Entrar",
        submitRegister: "Registrarme",
        chooseRole: "Elige si eres fan o creadora",
        fan: "Fan",
        creator: "Creadora / Vendedor",
        fanDescription: "Accedo a chats privados y compro contenido",
        creatorDescription: "Publico servicios, recibo propinas y cobro",
        forgotPassword: "¿Olvidaste tu contraseña?",
        resetSent: "Te hemos enviado un correo de recuperación",
        errorRole: "Elige si eres fan o creadora antes de continuar",
        accountCreated: "Cuenta creada",
        successLogin: "¡Bienvenido/a!",
        orContinueWith: "O continuar con",
        googleLogin: "Continuar con Google",
        fanDescriptionShort: "Sigo modelos y compro contenido",
        creatorDescriptionShort: "Vendo contenido y cobro propinas",
        hidePassword: "Ocultar contraseña",
        showPassword: "Mostrar contraseña",
        accountCreatedLogin: "¡Cuenta creada! Iniciando sesión...",
        referralError: "No se pudo registrar al fan invitador.",
        registerError: "Error al registrarse",
        authBack: "← Volver",
        namePlaceholderFan: "Tu nombre o apodo",
        namePlaceholderCreator: "Nombre público",
        passwordPlaceholder: "Mínimo 6 caracteres",
        inviterTitle: "¿Quién te ha invitado? (opcional)",
        inviterDescription: "Si llegaste gracias a un Fan VIP, escribe su nombre exacto. Si no te ha invitado nadie, puedes dejarlo vacío.",
        inviterLabel: "Nombre del Fan que te ha traído",
        inviterPlaceholder: "Nombre exacto del fan...",
        consumerPrivacyNote: "Como consumidor, tu perfil es privado. Tu nombre aparecerá en los chats de servicios que contrates.",
      },
      /* Common actions */
      common: {
        delete: "Eliminar",
        cancel: "Cancelar",
        confirm: "Confirmar",
        back: "Volver",
        error: "Error",
        by: "por",
        explore: "Explorar",
        noCancel: "No cancelar",
        yes: "Sí",
        no: "No",
        send: "Enviar solicitud",
      },
      /* Install banner */
      install: {
        title: "Descargar app STARTIP",
        subtitle: "Instala la app para una mejor experiencia",
        install: "Instalar",
        close: "Cerrar",
      },
      /* Navegación interna */
      nav: {
        myPanel: "Mi Panel",
        myServices: "Mis Servicios",
        home: "Inicio",
        logout: "Cerrar sesión",
        profile: "Mi Perfil",
        channels: "Canales",
        chats: "Chats",
        subscriptions: "Suscripciones",
        premium: "Premium",
        services: "Servicios",
      },
      /* Dashboard creador */
      dashboard: {
        balance: "Saldo",
        tips: "Propinas",
        services: "Servicios",
        withdrawals: "Retiros",
        totalEarned: "Ganado",
        loading: "CARGANDO...",
        noTips: "Aún no has recibido propinas",
        pendingVerification: "Tu perfil está pendiente de verificación. Completa tu perfil en Ajustes.",
        pendingVerification2: "Tu perfil esta pendiente de verificacion. Completa tu perfil en Ajustes.",
        withdraw: "Solicitar retiro",
        withdrawAmount: "Importe a retirar",
        errorLoading: "Error cargando datos",
        noMethod: "No tienes ningún método de cobro configurado.",
        noMethodDesc: "Ve a tu perfil y elige IBAN o PayPal antes de solicitar una retirada.",
        configureInProfile: "Configurar en mi perfil →",
        withdrawAmountLabel: "Cantidad a retirar",
        withdrawMin: "Mínimo",
        withdrawAvailable: "Disponible",
        withdrawAll: "Todo",
        sendingRequest: "Enviando solicitud...",
        confirmIbanWithdrawal: "Confirmar solicitud de retiro IBAN",
        needMoreBalance: "Necesitas al menos",
        toWithdraw: "para retirar. Te faltan",
        clientChats: "Chats de clientes",
        withdrawalCompleted: "Completado",
        withdrawalPending: "Pendiente",
        withdrawalShipped: "💸 Dinero en camino",
        withdrawalRejected: "Rechazado",
        withdrawalFailed: "Fallido",
        withdrawIban: "Retirar a IBAN",
        withdrawPaypal: "Retirar a PayPal (+1€)",
        chatOpen: "Abierto",
        chatClosed: "Completado",
        chatNone: "Sin chat",
        viewChat: "Ver chat",
        open: "Abrir",
        view: "Ver",
        newMessages: "nuevo",
        newMessagesPlural: "nuevos",
        noTipsYet: "No hay propinas aún",
        deleteWithdrawal: "Eliminar este retiro fallido/rechazado",
        confirmDeleteWithdrawal: "¿Eliminar este retiro fallido? Esta acción no se puede deshacer.",
        withdrawalDeleted: "Retiro eliminado",
        errorDeleteWithdrawal: "Error al eliminar el retiro",
        chatDeletedDash: "Chat eliminado de tu lista",
        errorDeleteChatDash: "Error al eliminar el chat",
        channelRequest1: "1 solicitud pendiente en tu canal",
        ibanDestination: "IBAN de destino",
        accountHolderName: "Nombre del titular de la cuenta",
        ibanCountryCode: "País (código ISO de 2 letras)",
        transferDetails: "Datos para la transferencia",
        requested: "Importe solicitado:",
        commission: "Comisión:",
        willReceiveBank: "Recibirás por banco:",
        willReceive: "Recibirás:",
        withdrawTo: "Para retirar por",
        changeInProfile: "cámbialo en",
        yourProfile: "tu perfil",
        feeCommission: "Comisión de retirada",
        noFee: "Sin comisión de monto (≥ 100 €)",
        profilePendingSetup: "Mi Contenido — te queda algo por configurar",
        myContent: "Mi Contenido",
        myProfile: "Mi Perfil",
        myChannels: "Mis Canales",
        createChannel: "Crear Canal",
        mySubscribers: "Mis suscriptores",
      },
      /* Panel fan/consumidor */
      consumer: {
        title: "Mis Servicios",
        noServices: "Todavía no has contratado ningún servicio.",
        explore: "Explorar creadores",
        buyMore: "+ Contratar más",
        configName: "Configura tu nombre",
        promotionApplied: "Promoción aplicada",
        validUntil: "Válido hasta el",
        chatPending: "Chat pendiente de activación por el creador",
        confirmDeleteChat: "¿Eliminar este chat de tu lista? Esta acción no puede deshacerse.",
        chatDeleted: "Chat eliminado de tu lista",
        errorDeleteChat: "Error al eliminar el chat",
        subscriptionCanceled: "Suscripción cancelada.",
        subscriptionDeleted: "Suscripción eliminada.",
        errorCancelSub: "Error al cancelar",
        errorDeleteSub: "Error al eliminar",
        cancelSubConfirm: "¿Cancelar suscripción? Seguirás activo hasta fin del período.",
        deleteSubConfirm: "¿Eliminar este registro? No se puede deshacer.",
        noServices2: "Todavía no has contratado ningún servicio. Explora los creadores de StarTip.",
        noSubs: "No tienes suscripciones activas. Explora los perfiles de las creadoras.",
        noPremium: "Sin suscripciones premium",
        noPremiumDesc: "Accede al contenido exclusivo de Drive de tus creadoras favoritas. Visita un perfil y suscríbete.",
        configNameDesc: "Los creadores te verán como \"Usuario\" hasta que pongas tu nombre. Ve a",
        configNameCTA: "Mi Perfil",
        configNameSuffix: "para añadir tu nombre o apodo.",
        privateChatDesc: "Solicitudes de chat privado que has enviado a creadores",
        requestChat: "+ Solicitar chat",
        viewExclusiveContent: "Ver contenido exclusivo",
        renewAccess: "Renovar acceso",
        requestReaccess: "Solicitar re-acceso",
        reaccessPending: "Solicitud pendiente…",
        reaccessTitle: "Solicitar re-acceso",
        reaccessDesc: "para recuperar el acceso a su contenido exclusivo.",
        reaccessInfo: "La creadora recibirá una notificación y podrá aceptar o rechazar tu solicitud.",
        reaccessSent: "Solicitud enviada. La creadora decidirá si aprobarte.",
        reaccessAlreadyPending: "Ya tienes una solicitud pendiente para este servicio.",
        reaccessError: "No se pudo enviar la solicitud",
        sendRequest: "Enviar solicitud",
        statusActive: "Activa",
        statusTrialing: "Prueba",
        statusPastDue: "Pago pendiente",
        statusCanceled: "Cancelada",
        statusIncomplete: "Incompleta",
        statusExpired: "Caducado",
        statusExpelled: "Expulsado",
        plan: "Plan",
        paid: "Pagado",
        daysRemaining: "Quedan",
        expiredLabel: "Caducó",
        accessUntil: "Acceso hasta",
        expiredOn: "Caducó el",
        cancelAtPeriodEnd: "(cancela al final del período)",
        nextRenewal: "Próxima renovación:",
        activeUntilColon: "Activa hasta:",
        exploreCreators: "Explorar creadores",
        exploreCreatorsF: "Explorar creadoras",
        subCount: "suscripción",
        subsCount: "suscripciones",
        registeredSub: "registrada",
        registeredSubs: "registradas",
        premiumSubs: "suscripción premium",
        premiumSubsPlural: "suscripciones premium",
        viewChat: "Ver chat",
        view: "Ver",
      },
      /* Chat */
      chat: {
        send: "Enviar",
        placeholder: "Escribe tu mensaje...",
        closed: "Chat cerrado (historial)",
        openChat: "Abrir chat con el creador",
        closeChat: "Cerrar chat",
        title: "Chat con admin",
      },
      /* TipPage */
      tipPage: {
        services: "Servicios",
        back: "Volver",
        tip: "Dar propina",
        buy: "Comprar",
        customAmount: "Cantidad personalizada",
        links: "Links",
        liveNow: "En directo",
        loading: "Cargando...",
        errorLoad: "No se pudo cargar",
        errorRequestChat: "Error al solicitar el chat",
        errorSubscription: "Error al iniciar la suscripción",
        selectAmount: "Selecciona un monto",
        privateChannel: "Canal privado",
        publicChannel: "Canal público",
        paymentCanceled: "Pago cancelado",
        payPrefix: "Pagar",
        selectAmountFirst: "Selecciona un monto",
      },
      /* Language selector */
      lang: {
        label: "Idioma",
        select: "Selecciona idioma",
      },
      /* Canal */
      channel: {
        loadMore: "Cargar más mensajes",
        noMessages: "Sin publicaciones todavía.",
        firstPost: "Sé el primero en publicar.",
        driveReconnectBanner: "Tu Drive necesita reconexión para cargar imágenes.",
        reconnectDrive: "Reconectar Drive",
        driveActive: "Drive activo",
        connectDrive: "Conectar Drive",
        commentPlaceholder: "Escribe un comentario",
        copy: "Copiar", pin: "Fijar", unpin: "Desfijar", edit: "Editar", delete: "Eliminar",
        fanPreviewOn: "Vista previa como fan", fanPreviewOff: "Salir de vista previa",
        hide: "Ocultar", schedule: "Programar", cancelSchedule: "Cancelar programación",
        linkCopied: "Enlace copiado", channelNotFound: "Canal no encontrado",
        requestSent: "Solicitud enviada. Espera la aprobación.",
        joined: "Te has unido al canal", left: "Has salido del canal", deleted: "Canal eliminado",
        pinSuccess: "Mensaje fijado", unpinSuccess: "Mensaje desfijado", deleteSuccess: "Mensaje eliminado",
        driveActivated: "Google Drive activado en este canal.", driveDeactivated: "Google Drive desactivado en este canal.",
        publishScheduled: "Publicación programada correctamente",
        videoTrimmed: "Tu vídeo era más largo de 15 segundos y fue recortado automáticamente.",
        uploadSuccess: "Archivo subido. Se eliminará automáticamente a los 15 días.",
        gifUploadSuccess: "GIF subido. Se eliminará automáticamente a los 15 días.",
        driveUploadSuccess: "Archivo subido a Drive y listo para publicar",
        gifUploading: "Subiendo GIF...", videoProcessing: "Procesando vídeo (puede tardar unos segundos)...", imageUploading: "Subiendo imagen...",
        errorEdit: "Error al editar", errorDelete: "Error al eliminar", errorPin: "Error al fijar",
        errorUpload: "Error al subir el archivo", errorGifUpload: "Error al subir el GIF",
        errorDriveUpload: "Error al subir el archivo a Drive", errorPublish: "Error al publicar",
        errorBackground: "No se pudo guardar el fondo", errorBubbleColor: "No se pudo guardar el color de burbuja",
        errorDriveConnect: "Error al conectar Drive. Inténtalo desde Contenido Premium.",
        driveReconnectNeeded: "Necesitas reconectar tu Google Drive en CONTENIDO PREMIUM",
        onlyImagesVideos: "Solo se permiten imágenes y vídeos", onlyGif: "Solo se permiten archivos GIF.",
      },
    },
  },

  /* ──────────────────────────────── ENGLISH ──────────────────────────────── */
  en: {
    translation: {
      STARTIP: "STARTIP",
      loading: "LOADING...",
      ageGate: {
        title: "Adult content",
        subtitle: "This site contains exclusive content for adults",
        confirm: "I AM OVER 18",
        deny: "I am underage",
        warning: "You must be of legal age to access.",
        legal: "Age confirmation is the exclusive responsibility of the user. STARTIP assumes no liability for false declarations.",
      },
      header: {
        login: "Log in",
        logout: "Log out",
        myPanel: "My Panel",
        myServices: "My services",
        chatAdmin: "Support chat",
        admin: "Admin",
      },
      hero: {
        title: "Make shine who you",
        titleHighlight: "admire",
        howItWorks: "How it works?",
        promotions: "Promotions",
        privacyTitle: "The art of selling, paying and collecting with greater privacy",
        privacyText: "On our platform, you can send and receive payments under an artistic name or alias, without revealing your real identity.\n\nYou don't need to share your IBAN or personal PayPal account with the buyer, avoiding exposing private and sensitive data.\n\nWe also protect the privacy of those who pay a seller, allowing their profile to contain an alias that does not correspond to their real name after a purchase.\n\nOur commitment is to ensure that when you sell and buy external links, anonymity and confidentiality can remain for both parties.",
        searchPlaceholder: "Search seller",
      },
      live: {
        liveNow: "LIVE NOW",
        badge: "LIVE",
        noLive: "No creator is live at the moment.",
        showAll: "View all creators",
      },
      filters: {
        label: "Filters",
        clearAll: "Clear all",
        gender: "Gender",
        all: "All",
        women: "Women",
        men: "Men",
        socialNetworks: "Social Networks",
        webcamLive: "Live webcam",
      },
      cards: {
        updated: "Updated",
        noModels: "No models available yet.",
        noResults: 'No models found for "{{search}}"',
      },
      pagination: {
        previous: "PREVIOUS",
        next: "NEXT",
      },
      footer: {
        legal: "Legal notice",
        privacy: "Privacy policy",
        cookies: "Cookie policy",
        contact: "Contact",
      },
      chat: {
        title: "Support chat",
        placeholder: "Type your message...",
        send: "Send",
        noMessages: "No messages yet. Write to us!",
      },
      auth: {
        login: "Log in",
        register: "Create account",
        email: "Email",
        password: "Password",
        name: "Name",
        alreadyHaveAccount: "Already have an account? Log in",
        noAccount: "Don't have an account? Sign up",
        submitLogin: "Enter",
        submitRegister: "Sign up",
        chooseRole: "Choose if you are a fan or creator",
        fan: "Fan",
        creator: "Creator / Seller",
        fanDescription: "I access private chats and purchase content",
        creatorDescription: "I publish services, receive tips and collect payments",
        forgotPassword: "Forgot your password?",
        resetSent: "We have sent you a recovery email",
        errorRole: "Choose if you are a fan or creator before continuing",
        accountCreated: "Account created",
        successLogin: "Welcome!",
        orContinueWith: "Or continue with",
        googleLogin: "Continue with Google",
        fanDescriptionShort: "I follow models and buy content",
        creatorDescriptionShort: "I sell content and collect tips",
        hidePassword: "Hide password",
        showPassword: "Show password",
        accountCreatedLogin: "Account created! Logging in...",
        referralError: "Could not register the referring fan.",
        registerError: "Registration error",
        authBack: "← Back",
        namePlaceholderFan: "Your name or nickname",
        namePlaceholderCreator: "Public name",
        passwordPlaceholder: "Minimum 6 characters",
        inviterTitle: "Who invited you? (optional)",
        inviterDescription: "If a VIP Fan brought you here, write their exact name. Otherwise, leave it empty.",
        inviterLabel: "Name of the Fan who invited you",
        inviterPlaceholder: "Fan's exact name...",
        consumerPrivacyNote: "As a consumer, your profile is private. Your name will appear in the chats of services you purchase.",
      },
      common: {
        delete: "Delete",
        cancel: "Cancel",
        confirm: "Confirm",
        back: "Back",
        error: "Error",
        by: "by",
        explore: "Explore",
        noCancel: "Keep",
        yes: "Yes",
        no: "No",
        send: "Send request",
      },
      install: {
        title: "Download STARTIP app",
        subtitle: "Install the app for a better experience",
        install: "Install",
        close: "Close",
      },
      /* Internal navigation */
      nav: {
        myPanel: "My Panel",
        myServices: "My Services",
        home: "Home",
        logout: "Log out",
        profile: "My Profile",
        channels: "Channels",
        chats: "Chats",
        subscriptions: "Subscriptions",
        premium: "Premium",
        services: "Services",
      },
      /* Creator dashboard */
      dashboard: {
        balance: "Balance",
        tips: "Tips",
        services: "Services",
        withdrawals: "Withdrawals",
        totalEarned: "Earned",
        loading: "LOADING...",
        noTips: "You haven't received any tips yet",
        pendingVerification: "Your profile is pending verification. Complete your profile in Settings.",
        pendingVerification2: "Your profile is pending verification. Complete your profile in Settings.",
        withdraw: "Request withdrawal",
        withdrawAmount: "Amount to withdraw",
        errorLoading: "Error loading data",
        noMethod: "You have no payout method configured.",
        noMethodDesc: "Go to your profile and choose IBAN or PayPal before requesting a withdrawal.",
        configureInProfile: "Configure in my profile →",
        withdrawAmountLabel: "Amount to withdraw",
        withdrawMin: "Minimum",
        withdrawAvailable: "Available",
        withdrawAll: "All",
        sendingRequest: "Sending request...",
        confirmIbanWithdrawal: "Confirm IBAN withdrawal request",
        needMoreBalance: "You need at least",
        toWithdraw: "to withdraw. You are missing",
        clientChats: "Client chats",
        withdrawalCompleted: "Completed",
        withdrawalPending: "Pending",
        withdrawalShipped: "💸 Money on the way",
        withdrawalRejected: "Rejected",
        withdrawalFailed: "Failed",
        withdrawIban: "Withdraw to IBAN",
        withdrawPaypal: "Withdraw to PayPal (+1€)",
        chatOpen: "Open",
        chatClosed: "Completed",
        chatNone: "No chat",
        viewChat: "View chat",
        open: "Open",
        view: "View",
        newMessages: "new",
        newMessagesPlural: "new",
        noTipsYet: "No tips yet",
        deleteWithdrawal: "Delete this failed/rejected withdrawal",
        confirmDeleteWithdrawal: "Delete this failed withdrawal? This action cannot be undone.",
        withdrawalDeleted: "Withdrawal deleted",
        errorDeleteWithdrawal: "Error deleting withdrawal",
        chatDeletedDash: "Chat removed from your list",
        errorDeleteChatDash: "Error deleting chat",
        channelRequest1: "1 pending request in your channel",
        ibanDestination: "Destination IBAN",
        accountHolderName: "Account holder name",
        ibanCountryCode: "Country (2-letter ISO code)",
        transferDetails: "Transfer details",
        requested: "Requested amount:",
        commission: "Fee:",
        willReceiveBank: "You will receive by bank:",
        willReceive: "You will receive:",
        noFee: "No fee (≥ 100 €)",
      },
      /* Fan/consumer panel */
      consumer: {
        title: "My Services",
        noServices: "You haven't purchased any service yet.",
        explore: "Explore creators",
        buyMore: "+ Buy more",
        configName: "Set up your name",
        promotionApplied: "Promotion applied",
        validUntil: "Valid until",
        chatPending: "Chat pending activation by the creator",
        confirmDeleteChat: "Delete this chat from your list? This action cannot be undone.",
        chatDeleted: "Chat removed from your list",
        errorDeleteChat: "Error deleting chat",
        subscriptionCanceled: "Subscription canceled.",
        subscriptionDeleted: "Subscription deleted.",
        errorCancelSub: "Error canceling",
        errorDeleteSub: "Error deleting",
        cancelSubConfirm: "Cancel subscription? You'll stay active until the end of the period.",
        deleteSubConfirm: "Delete this record? This cannot be undone.",
        noServices2: "You haven't purchased any service yet. Explore StarTip creators.",
        noSubs: "You have no active subscriptions. Explore creator profiles.",
        noPremium: "No premium subscriptions",
        noPremiumDesc: "Access exclusive Drive content from your favourite creators. Visit a profile and subscribe.",
        configNameDesc: "Creators will see you as \"User\" until you set your name. Go to",
        configNameCTA: "My Profile",
        configNameSuffix: "to add your name or nickname.",
        privateChatDesc: "Private chat requests you have sent to creators",
        requestChat: "+ Request chat",
        viewExclusiveContent: "View exclusive content",
        renewAccess: "Renew access",
        requestReaccess: "Request re-access",
        reaccessPending: "Request pending…",
        reaccessTitle: "Request re-access",
        reaccessDesc: "to recover access to their exclusive content.",
        reaccessInfo: "The creator will receive a notification and can accept or reject your request.",
        reaccessSent: "Request sent. The creator will decide whether to approve you.",
        reaccessAlreadyPending: "You already have a pending request for this service.",
        reaccessError: "Could not send the request",
        sendRequest: "Send request",
        statusActive: "Active",
        statusTrialing: "Trial",
        statusPastDue: "Payment pending",
        statusCanceled: "Canceled",
        statusIncomplete: "Incomplete",
        statusExpired: "Expired",
        statusExpelled: "Expelled",
        plan: "Plan",
        paid: "Paid",
        daysRemaining: "Remaining",
        expiredLabel: "Expired",
        accessUntil: "Access until",
        expiredOn: "Expired on",
        cancelAtPeriodEnd: "(cancels at period end)",
        nextRenewal: "Next renewal:",
        activeUntilColon: "Active until:",
        exploreCreators: "Explore creators",
        exploreCreatorsF: "Explore creators",
        subCount: "subscription",
        subsCount: "subscriptions",
        registeredSub: "registered",
        registeredSubs: "registered",
        premiumSubs: "premium subscription",
        premiumSubsPlural: "premium subscriptions",
        viewChat: "View chat",
        view: "View",
      },
      /* Chat */
      chat: {
        send: "Send",
        placeholder: "Write your message...",
        closed: "Chat closed (history)",
        openChat: "Open chat with creator",
        closeChat: "Close chat",
        title: "Chat with admin",
      },
      /* TipPage */
      tipPage: {
        services: "Services",
        back: "Back",
        tip: "Send tip",
        buy: "Buy now",
        customAmount: "Custom amount",
        links: "Links",
        liveNow: "Live now",
        loading: "Loading...",
        errorLoad: "Could not load",
        errorRequestChat: "Error requesting chat",
        errorSubscription: "Error starting subscription",
        selectAmount: "Select an amount",
        privateChannel: "Private channel",
        publicChannel: "Public channel",
        paymentCanceled: "Payment canceled",
        payPrefix: "Pay",
        selectAmountFirst: "Select an amount",
      },
      lang: {
        label: "Language",
        select: "Select language",
      },
      channel: {
        loadMore: "Load more messages", noMessages: "No posts yet.", firstPost: "Be the first to post.",
        driveReconnectBanner: "Your Drive needs reconnection to load images.", reconnectDrive: "Reconnect Drive",
        driveActive: "Drive active", connectDrive: "Connect Drive", commentPlaceholder: "Write a comment",
        copy: "Copy", pin: "Pin", unpin: "Unpin", edit: "Edit", delete: "Delete",
        fanPreviewOn: "Fan preview", fanPreviewOff: "Exit fan preview",
        hide: "Hide", schedule: "Schedule", cancelSchedule: "Cancel scheduling",
        linkCopied: "Link copied", channelNotFound: "Channel not found",
        requestSent: "Request sent. Awaiting approval.", joined: "You joined the channel",
        left: "You left the channel", deleted: "Channel deleted",
        pinSuccess: "Message pinned", unpinSuccess: "Message unpinned", deleteSuccess: "Message deleted",
        driveActivated: "Google Drive activated in this channel.", driveDeactivated: "Google Drive deactivated in this channel.",
        publishScheduled: "Post scheduled successfully",
        videoTrimmed: "Your video was longer than 15 seconds and was automatically trimmed.",
        uploadSuccess: "File uploaded. It will be automatically deleted after 15 days.",
        gifUploadSuccess: "GIF uploaded. It will be automatically deleted after 15 days.",
        driveUploadSuccess: "File uploaded to Drive and ready to publish",
        gifUploading: "Uploading GIF...", videoProcessing: "Processing video (may take a few seconds)...", imageUploading: "Uploading image...",
        errorEdit: "Edit error", errorDelete: "Delete error", errorPin: "Pin error",
        errorUpload: "File upload error", errorGifUpload: "GIF upload error",
        errorDriveUpload: "Drive upload error", errorPublish: "Publish error",
        errorBackground: "Could not save background", errorBubbleColor: "Could not save bubble color",
        errorDriveConnect: "Error connecting Drive. Try from Premium Content.",
        driveReconnectNeeded: "You need to reconnect your Google Drive in PREMIUM CONTENT",
        onlyImagesVideos: "Only images and videos are allowed", onlyGif: "Only GIF files are allowed.",
      },
    },
  },

  /* ──────────────────────────────── FRANÇAIS ─────────────────────────────── */
  fr: {
    translation: {
      STARTIP: "STARTIP",
      loading: "CHARGEMENT...",
      ageGate: {
        title: "Contenu pour adultes",
        subtitle: "Ce site contient du contenu exclusif pour adultes",
        confirm: "J'AI PLUS DE 18 ANS",
        deny: "Je suis mineur",
        warning: "Vous devez être majeur pour accéder.",
        legal: "La confirmation de majorité est de la responsabilité exclusive de l'utilisateur. STARTIP n'assume aucune responsabilité pour les fausses déclarations.",
      },
      header: {
        login: "Se connecter",
        logout: "Se déconnecter",
        myPanel: "Mon espace",
        myServices: "Mes services",
        chatAdmin: "Chat support",
        admin: "Admin",
      },
      hero: {
        title: "Faites briller ceux que vous",
        titleHighlight: "admirez",
        howItWorks: "Comment ça marche ?",
        promotions: "Promotions",
        privacyTitle: "L'art de vendre, payer et encaisser avec plus de confidentialité",
        privacyText: "Sur notre plateforme, vous pouvez recevoir et effectuer des paiements sous un nom artistique ou alias, sans révéler votre véritable identité.\n\nVous n'avez pas besoin de partager votre IBAN ni votre compte PayPal personnel avec l'acheteur, évitant ainsi d'exposer des données privées et sensibles.\n\nNous protégeons également la vie privée de ceux qui paient un vendeur, en permettant que leur profil contienne un alias ne correspondant pas à leur vrai nom après un achat.\n\nNotre engagement est de faire en sorte que lorsque vous vendez et achetez des liens externes, l'anonymat et la confidentialité puissent perdurer pour les deux parties.",
        searchPlaceholder: "Rechercher un vendeur",
      },
      live: {
        liveNow: "EN DIRECT MAINTENANT",
        badge: "EN DIRECT",
        noLive: "Aucun créateur n'est en direct pour le moment.",
        showAll: "Voir tous les créateurs",
      },
      filters: {
        label: "Filtres",
        clearAll: "Tout effacer",
        gender: "Genre",
        all: "Tous",
        women: "Femmes",
        men: "Hommes",
        socialNetworks: "Réseaux sociaux",
        webcamLive: "Webcam en direct",
      },
      cards: {
        updated: "Mis à jour",
        noModels: "Aucun modèle disponible pour le moment.",
        noResults: 'Aucun modèle trouvé pour "{{search}}"',
      },
      pagination: {
        previous: "PRÉCÉDENT",
        next: "SUIVANT",
      },
      footer: {
        legal: "Mentions légales",
        privacy: "Politique de confidentialité",
        cookies: "Politique de cookies",
        contact: "Contact",
      },
      chat: {
        title: "Chat support",
        placeholder: "Tapez votre message...",
        send: "Envoyer",
        noMessages: "Pas encore de messages. Écrivez-nous !",
      },
      auth: {
        login: "Se connecter",
        register: "Créer un compte",
        email: "Email",
        password: "Mot de passe",
        name: "Nom",
        alreadyHaveAccount: "Déjà un compte ? Se connecter",
        noAccount: "Pas de compte ? S'inscrire",
        submitLogin: "Entrer",
        submitRegister: "S'inscrire",
        chooseRole: "Choisissez si vous êtes fan ou créateur",
        fan: "Fan",
        creator: "Créateur / Vendeur",
        fanDescription: "J'accède aux chats privés et j'achète du contenu",
        creatorDescription: "Je publie des services, reçois des pourboires et encaisse",
        forgotPassword: "Mot de passe oublié ?",
        resetSent: "Nous vous avons envoyé un e-mail de récupération",
        errorRole: "Choisissez si vous êtes fan ou créateur avant de continuer",
        accountCreated: "Compte créé",
        successLogin: "Bienvenue !",
        orContinueWith: "Ou continuer avec",
        googleLogin: "Continuer avec Google",
        fanDescriptionShort: "Je suis des modèles et achète du contenu",
        creatorDescriptionShort: "Je vends du contenu et encaisse des pourboires",
        hidePassword: "Masquer le mot de passe",
        showPassword: "Afficher le mot de passe",
        accountCreatedLogin: "Compte créé ! Connexion en cours...",
        referralError: "Impossible d'enregistrer le fan parrain.",
        registerError: "Erreur d'inscription",
        authBack: "← Retour",
        namePlaceholderFan: "Votre nom ou pseudo",
        namePlaceholderCreator: "Nom public",
        passwordPlaceholder: "Minimum 6 caractères",
        inviterTitle: "Qui vous a invité ? (facultatif)",
        inviterDescription: "Si un Fan VIP vous a amené ici, écrivez son nom exact. Sinon, laissez vide.",
        inviterLabel: "Nom du Fan qui vous a invité",
        inviterPlaceholder: "Nom exact du fan...",
        consumerPrivacyNote: "En tant que consommateur, votre profil est privé. Votre nom apparaîtra dans les chats des services achetés.",
      },
      common: {
        delete: "Supprimer",
        cancel: "Annuler",
        confirm: "Confirmer",
        back: "Retour",
        error: "Erreur",
        by: "par",
        explore: "Explorer",
        noCancel: "Garder",
        yes: "Oui",
        no: "Non",
        send: "Envoyer la demande",
      },
      install: {
        title: "Télécharger l'app STARTIP",
        subtitle: "Installez l'app pour une meilleure expérience",
        install: "Installer",
        close: "Fermer",
      },
      nav: { myPanel: "Mon espace", myServices: "Mes services", home: "Accueil", logout: "Déconnexion", profile: "Mon profil", channels: "Chaînes", chats: "Chats", subscriptions: "Abonnements", premium: "Premium", services: "Services" },
      dashboard: { balance: "Solde", tips: "Pourboires", services: "Services", withdrawals: "Retraits", totalEarned: "Gagné", loading: "CHARGEMENT...", noTips: "Vous n'avez pas encore reçu de pourboires", pendingVerification: "Votre profil est en attente de vérification.", pendingVerification2: "Votre profil est en attente de vérification.", withdraw: "Demander un retrait", withdrawAmount: "Montant à retirer", errorLoading: "Erreur de chargement", noMethod: "Aucun mode de paiement configuré.", noMethodDesc: "Allez dans votre profil et choisissez IBAN ou PayPal.", configureInProfile: "Configurer dans mon profil →", withdrawAmountLabel: "Montant à retirer", withdrawMin: "Minimum", withdrawAvailable: "Disponible", withdrawAll: "Tout", sendingRequest: "Envoi en cours...", confirmIbanWithdrawal: "Confirmer la demande de retrait IBAN", needMoreBalance: "Vous avez besoin d'au moins", toWithdraw: "pour retirer. Il vous manque", clientChats: "Chats clients", withdrawalCompleted: "Terminé", withdrawalPending: "En attente", withdrawalShipped: "💸 Argent en route", withdrawalRejected: "Rejeté", withdrawalFailed: "Échoué", withdrawIban: "Retirer vers IBAN", withdrawPaypal: "Retirer vers PayPal (+1€)", chatOpen: "Ouvert", chatClosed: "Terminé", chatNone: "Pas de chat", viewChat: "Voir le chat", open: "Ouvrir", view: "Voir", newMessages: "nouveau", newMessagesPlural: "nouveaux", noTipsYet: "Pas encore de pourboires", deleteWithdrawal: "Supprimer ce retrait échoué", withdrawalDeleted: "Retrait supprimé", errorDeleteWithdrawal: "Erreur lors de la suppression", chatDeletedDash: "Chat supprimé de votre liste", errorDeleteChatDash: "Erreur suppression chat", ibanDestination: "IBAN de destination", accountHolderName: "Nom du titulaire du compte", ibanCountryCode: "Pays (code ISO 2 lettres)", transferDetails: "Détails du virement", requested: "Montant demandé :", commission: "Commission :", willReceiveBank: "Vous recevrez par virement :", willReceive: "Vous recevrez :", noFee: "Sans commission (≥ 100 €)" },
      consumer: { title: "Mes Services", noServices: "Vous n'avez encore acheté aucun service.", explore: "Explorer les créateurs", buyMore: "+ Acheter plus", configName: "Configurez votre nom", promotionApplied: "Promotion appliquée", validUntil: "Valable jusqu'au", chatPending: "Chat en attente d'activation par le créateur", confirmDeleteChat: "Supprimer ce chat de votre liste ? Cette action est irréversible.", chatDeleted: "Chat supprimé de votre liste", errorDeleteChat: "Erreur lors de la suppression du chat", subscriptionCanceled: "Abonnement annulé.", subscriptionDeleted: "Abonnement supprimé.", errorCancelSub: "Erreur lors de l'annulation", errorDeleteSub: "Erreur lors de la suppression", cancelSubConfirm: "Annuler l'abonnement ? Vous resterez actif jusqu'à la fin de la période.", deleteSubConfirm: "Supprimer ce record ? Impossible d'annuler.", noServices2: "Vous n'avez encore acheté aucun service. Explorez les créateurs.", noSubs: "Vous n'avez aucun abonnement actif.", noPremium: "Aucun abonnement premium", noPremiumDesc: "Accédez au contenu exclusif Drive de vos créateurs favoris.", configNameDesc: "Les créateurs vous verront comme « Utilisateur » jusqu'à ce que vous définissiez votre nom. Allez à", configNameCTA: "Mon Profil", configNameSuffix: "pour ajouter votre nom.", privateChatDesc: "Demandes de chat privé envoyées aux créateurs", requestChat: "+ Demander un chat", viewExclusiveContent: "Voir le contenu exclusif", renewAccess: "Renouveler l'accès", requestReaccess: "Demander un re-accès", reaccessPending: "Demande en attente…", reaccessTitle: "Demander un re-accès", reaccessDesc: "pour récupérer l'accès à son contenu exclusif.", reaccessInfo: "Le créateur recevra une notification et pourra accepter ou refuser votre demande.", reaccessSent: "Demande envoyée.", reaccessAlreadyPending: "Vous avez déjà une demande en attente.", reaccessError: "Impossible d'envoyer la demande", sendRequest: "Envoyer la demande", statusActive: "Actif", statusTrialing: "Essai", statusPastDue: "Paiement en attente", statusCanceled: "Annulé", statusIncomplete: "Incomplet", statusExpired: "Expiré", statusExpelled: "Expulsé", plan: "Plan", paid: "Payé", daysRemaining: "Restant", expiredLabel: "Expiré", accessUntil: "Accès jusqu'au", expiredOn: "Expiré le", cancelAtPeriodEnd: "(annule en fin de période)", nextRenewal: "Prochain renouvellement :", activeUntilColon: "Actif jusqu'au :", exploreCreators: "Explorer les créateurs", exploreCreatorsF: "Explorer les créateurs", subCount: "abonnement", subsCount: "abonnements", registeredSub: "enregistré", registeredSubs: "enregistrés", premiumSubs: "abonnement premium", premiumSubsPlural: "abonnements premium", viewChat: "Voir le chat", view: "Voir" },
      chat: { send: "Envoyer", placeholder: "Écrivez votre message...", closed: "Chat fermé (historique)", openChat: "Ouvrir le chat avec le créateur", closeChat: "Fermer le chat", title: "Chat avec l'admin" },
      tipPage: { services: "Services", back: "Retour", tip: "Envoyer un pourboire", buy: "Acheter", customAmount: "Montant personnalisé", links: "Liens", liveNow: "En direct", loading: "Chargement...", errorLoad: "Impossible de charger", errorRequestChat: "Erreur lors de la demande de chat", errorSubscription: "Erreur de démarrage d'abonnement", selectAmount: "Sélectionnez un montant", privateChannel: "Canal privé", publicChannel: "Canal public", paymentCanceled: "Paiement annulé", payPrefix: "Payer", selectAmountFirst: "Sélectionnez un montant" },
      lang: { label: "Langue", select: "Choisir la langue" },
      channel: {
        loadMore: "Charger plus de messages", noMessages: "Pas encore de publications.", firstPost: "Soyez le premier à publier.",
        driveReconnectBanner: "Votre Drive nécessite une reconnexion pour charger les images.", reconnectDrive: "Reconnecter Drive",
        driveActive: "Drive actif", connectDrive: "Connecter Drive", commentPlaceholder: "Écrire un commentaire",
        copy: "Copier", pin: "Épingler", unpin: "Désépingler", edit: "Modifier", delete: "Supprimer",
        fanPreviewOn: "Aperçu fan", fanPreviewOff: "Quitter l'aperçu",
        hide: "Masquer", schedule: "Planifier", cancelSchedule: "Annuler la planification",
        linkCopied: "Lien copié", channelNotFound: "Canal introuvable",
        requestSent: "Demande envoyée. En attente d'approbation.", joined: "Vous avez rejoint la chaîne",
        left: "Vous avez quitté la chaîne", deleted: "Chaîne supprimée",
        pinSuccess: "Message épinglé", unpinSuccess: "Message désépinglé", deleteSuccess: "Message supprimé",
        driveActivated: "Google Drive activé sur cette chaîne.", driveDeactivated: "Google Drive désactivé sur cette chaîne.",
        publishScheduled: "Publication planifiée avec succès",
        videoTrimmed: "Votre vidéo dépassait 15 secondes et a été automatiquement coupée.",
        uploadSuccess: "Fichier téléchargé. Il sera automatiquement supprimé après 15 jours.",
        gifUploadSuccess: "GIF téléchargé. Il sera automatiquement supprimé après 15 jours.",
        driveUploadSuccess: "Fichier téléchargé sur Drive et prêt à publier",
        gifUploading: "Téléchargement du GIF...", videoProcessing: "Traitement de la vidéo...", imageUploading: "Téléchargement de l'image...",
        errorEdit: "Erreur d'édition", errorDelete: "Erreur de suppression", errorPin: "Erreur d'épinglage",
        errorUpload: "Erreur de téléchargement", errorGifUpload: "Erreur GIF", errorDriveUpload: "Erreur Drive",
        errorPublish: "Erreur de publication", errorBackground: "Impossible de sauvegarder l'arrière-plan",
        errorBubbleColor: "Impossible de sauvegarder la couleur",
        errorDriveConnect: "Erreur Drive. Essayez depuis le Contenu Premium.",
        driveReconnectNeeded: "Vous devez reconnecter votre Google Drive dans le CONTENU PREMIUM",
        onlyImagesVideos: "Seules les images et vidéos sont autorisées", onlyGif: "Seuls les fichiers GIF sont autorisés.",
      },
    },
  },

  /* ──────────────────────────────── DEUTSCH ──────────────────────────────── */
  de: {
    translation: {
      STARTIP: "STARTIP",
      loading: "LADEN...",
      ageGate: {
        title: "Inhalte für Erwachsene",
        subtitle: "Diese Website enthält exklusive Inhalte für Erwachsene",
        confirm: "ICH BIN ÜBER 18",
        deny: "Ich bin minderjährig",
        warning: "Sie müssen volljährig sein, um zuzugreifen.",
        legal: "Die Altersbestätigung liegt in der ausschließlichen Verantwortung des Nutzers. STARTIP übernimmt keine Haftung für falsche Angaben.",
      },
      header: {
        login: "Anmelden",
        logout: "Abmelden",
        myPanel: "Mein Bereich",
        myServices: "Meine Dienste",
        chatAdmin: "Support-Chat",
        admin: "Admin",
      },
      hero: {
        title: "Lass diejenigen strahlen, die du",
        titleHighlight: "bewunderst",
        howItWorks: "Wie funktioniert es?",
        promotions: "Aktionen",
        privacyTitle: "Die Kunst, mit mehr Privatsphäre zu verkaufen, zu zahlen und zu kassieren",
        privacyText: "Auf unserer Plattform können Sie Zahlungen unter einem Künstlernamen oder Alias empfangen und leisten, ohne Ihre wahre Identität preiszugeben.\n\nSie müssen Ihren IBAN oder Ihr persönliches PayPal-Konto nicht mit dem Käufer teilen und vermeiden so die Preisgabe privater und sensibler Daten.\n\nWir schützen auch die Privatsphäre derjenigen, die einem Verkäufer zahlen, indem wir erlauben, dass ihr Profil einen Alias enthalten kann, der nach einem Kauf nicht ihrem echten Namen entspricht.\n\nUnser Ziel ist es sicherzustellen, dass beim Kauf und Verkauf externer Links Anonymität und Vertraulichkeit für beide Parteien gewahrt bleibt.",
        searchPlaceholder: "Verkäufer suchen",
      },
      live: {
        liveNow: "JETZT LIVE",
        badge: "LIVE",
        noLive: "Im Moment ist kein Creator live.",
        showAll: "Alle Creator anzeigen",
      },
      filters: {
        label: "Filter",
        clearAll: "Alles löschen",
        gender: "Geschlecht",
        all: "Alle",
        women: "Frauen",
        men: "Männer",
        socialNetworks: "Soziale Netzwerke",
        webcamLive: "Webcam live",
      },
      cards: {
        updated: "Aktualisiert",
        noModels: "Noch keine Modelle verfügbar.",
        noResults: 'Keine Modelle gefunden für "{{search}}"',
      },
      pagination: { previous: "VORHERIGE", next: "NÄCHSTE" },
      footer: {
        legal: "Impressum",
        privacy: "Datenschutzrichtlinie",
        cookies: "Cookie-Richtlinie",
        contact: "Kontakt",
      },
      chat: {
        title: "Support-Chat",
        placeholder: "Schreibe deine Nachricht...",
        send: "Senden",
        noMessages: "Noch keine Nachrichten. Schreib uns!",
      },
      auth: {
        login: "Anmelden",
        register: "Konto erstellen",
        email: "E-Mail",
        password: "Passwort",
        name: "Name",
        alreadyHaveAccount: "Hast du bereits ein Konto? Anmelden",
        noAccount: "Kein Konto? Registrieren",
        submitLogin: "Einloggen",
        submitRegister: "Registrieren",
        chooseRole: "Wähle, ob du Fan oder Creator bist",
        fan: "Fan",
        creator: "Creator / Verkäufer",
        fanDescription: "Ich habe Zugang zu privaten Chats und kaufe Inhalte",
        creatorDescription: "Ich veröffentliche Dienste, erhalte Trinkgelder und kassiere",
        forgotPassword: "Passwort vergessen?",
        resetSent: "Wir haben dir eine Wiederherstellungs-E-Mail gesendet",
        errorRole: "Wähle Fan oder Creator, bevor du fortfährst",
        accountCreated: "Konto erstellt",
        successLogin: "Willkommen!",
        orContinueWith: "Oder weiter mit",
        googleLogin: "Weiter mit Google",
        fanDescriptionShort: "Ich folge Models und kaufe Inhalte",
        creatorDescriptionShort: "Ich verkaufe Inhalte und kassiere Trinkgelder",
        hidePassword: "Passwort ausblenden",
        showPassword: "Passwort anzeigen",
        accountCreatedLogin: "Konto erstellt! Einloggen...",
        referralError: "Fan-Empfehlung konnte nicht registriert werden.",
        registerError: "Registrierungsfehler",
        authBack: "← Zurück",
        namePlaceholderFan: "Dein Name oder Spitzname",
        namePlaceholderCreator: "Öffentlicher Name",
        passwordPlaceholder: "Mindestens 6 Zeichen",
        inviterTitle: "Wer hat dich eingeladen? (optional)",
        inviterDescription: "Falls dich ein VIP-Fan hierher gebracht hat, schreib seinen genauen Namen. Sonst leer lassen.",
        inviterLabel: "Name des Fans, der dich eingeladen hat",
        inviterPlaceholder: "Genauer Name des Fans...",
        consumerPrivacyNote: "Als Verbraucher ist dein Profil privat. Dein Name erscheint in den Chats der gebuchten Dienste.",
      },
      common: {
        delete: "Löschen",
        cancel: "Abbrechen",
        confirm: "Bestätigen",
        back: "Zurück",
        error: "Fehler",
        by: "von",
        explore: "Erkunden",
        noCancel: "Behalten",
        yes: "Ja",
        no: "Nein",
        send: "Anfrage senden",
      },
      install: {
        title: "STARTIP App herunterladen",
        subtitle: "Installiere die App für ein besseres Erlebnis",
        install: "Installieren",
        close: "Schließen",
      },
      nav: { myPanel: "Mein Panel", myServices: "Meine Dienste", home: "Startseite", logout: "Abmelden", profile: "Mein Profil", channels: "Kanäle", chats: "Chats", subscriptions: "Abonnements", premium: "Premium", services: "Dienste" },
      dashboard: { balance: "Guthaben", tips: "Trinkgelder", services: "Dienste", withdrawals: "Auszahlungen", totalEarned: "Verdient", loading: "WIRD GELADEN...", noTips: "Sie haben noch keine Trinkgelder erhalten", pendingVerification: "Ihr Profil wartet auf Verifizierung.", pendingVerification2: "Ihr Profil wartet auf Verifizierung.", withdraw: "Auszahlung beantragen", withdrawAmount: "Auszahlungsbetrag", errorLoading: "Fehler beim Laden", noMethod: "Keine Auszahlungsmethode konfiguriert.", noMethodDesc: "Geh in dein Profil und wähle IBAN oder PayPal.", configureInProfile: "Im Profil einrichten →", withdrawAmountLabel: "Auszahlungsbetrag", withdrawMin: "Minimum", withdrawAvailable: "Verfügbar", withdrawAll: "Alles", sendingRequest: "Anfrage senden...", confirmIbanWithdrawal: "IBAN-Auszahlungsantrag bestätigen", needMoreBalance: "Du brauchst mindestens", toWithdraw: "zum Auszahlen. Dir fehlen noch", clientChats: "Kundenchats", withdrawalCompleted: "Abgeschlossen", withdrawalPending: "Ausstehend", withdrawalShipped: "💸 Geld unterwegs", withdrawalRejected: "Abgelehnt", withdrawalFailed: "Fehlgeschlagen", withdrawIban: "An IBAN auszahlen", withdrawPaypal: "An PayPal auszahlen (+1€)", chatOpen: "Offen", chatClosed: "Abgeschlossen", chatNone: "Kein Chat", viewChat: "Chat anzeigen", open: "Öffnen", view: "Ansehen", newMessages: "neu", newMessagesPlural: "neue", noTipsYet: "Noch keine Trinkgelder", deleteWithdrawal: "Fehlgeschlagene Auszahlung löschen", withdrawalDeleted: "Auszahlung gelöscht", errorDeleteWithdrawal: "Fehler beim Löschen", chatDeletedDash: "Chat von deiner Liste entfernt", errorDeleteChatDash: "Fehler beim Löschen", ibanDestination: "Ziel-IBAN", accountHolderName: "Name des Kontoinhabers", ibanCountryCode: "Land (2-Buchstaben ISO-Code)", transferDetails: "Überweisungsdetails", requested: "Angefordert:", commission: "Provision:", willReceiveBank: "Du erhältst per Überweisung:", willReceive: "Du erhältst:", noFee: "Keine Gebühr (≥ 100 €)" },
      consumer: { title: "Meine Dienste", noServices: "Sie haben noch keinen Dienst erworben.", explore: "Ersteller entdecken", buyMore: "+ Mehr kaufen", configName: "Namen einrichten", promotionApplied: "Aktionscode angewendet", validUntil: "Gültig bis", chatPending: "Chat wartet auf Aktivierung durch den Ersteller", confirmDeleteChat: "Chat aus der Liste entfernen? Diese Aktion ist unwiderruflich.", chatDeleted: "Chat aus der Liste entfernt", errorDeleteChat: "Fehler beim Löschen des Chats", subscriptionCanceled: "Abonnement gekündigt.", subscriptionDeleted: "Abonnement gelöscht.", errorCancelSub: "Fehler beim Kündigen", errorDeleteSub: "Fehler beim Löschen", cancelSubConfirm: "Abonnement kündigen? Du bleibst bis Periodenende aktiv.", deleteSubConfirm: "Diesen Eintrag löschen? Nicht rückgängig zu machen.", noServices2: "Sie haben noch keinen Dienst erworben.", noSubs: "Keine aktiven Abonnements.", noPremium: "Keine Premium-Abonnements", noPremiumDesc: "Greif auf exklusive Drive-Inhalte deiner Lieblingsersteller zu.", configNameDesc: "Ersteller sehen dich als «Benutzer», bis du deinen Namen einrichtest. Geh zu", configNameCTA: "Mein Profil", configNameSuffix: "um deinen Namen hinzuzufügen.", privateChatDesc: "Private Chat-Anfragen, die du an Ersteller gesendet hast", requestChat: "+ Chat anfragen", viewExclusiveContent: "Exklusiven Inhalt ansehen", renewAccess: "Zugang erneuern", requestReaccess: "Erneuten Zugang anfragen", reaccessPending: "Anfrage ausstehend…", reaccessTitle: "Erneuten Zugang anfragen", reaccessDesc: "um Zugang zu dessen exklusivem Inhalt wiederzuerlangen.", reaccessInfo: "Der Ersteller erhält eine Benachrichtigung und kann deine Anfrage annehmen oder ablehnen.", reaccessSent: "Anfrage gesendet.", reaccessAlreadyPending: "Du hast bereits eine ausstehende Anfrage.", reaccessError: "Anfrage konnte nicht gesendet werden", sendRequest: "Anfrage senden", statusActive: "Aktiv", statusTrialing: "Test", statusPastDue: "Zahlung ausstehend", statusCanceled: "Gekündigt", statusIncomplete: "Unvollständig", statusExpired: "Abgelaufen", statusExpelled: "Ausgeschlossen", plan: "Plan", paid: "Bezahlt", daysRemaining: "Verbleibend", expiredLabel: "Abgelaufen", accessUntil: "Zugang bis", expiredOn: "Abgelaufen am", cancelAtPeriodEnd: "(kündigt am Periodenende)", nextRenewal: "Nächste Verlängerung:", activeUntilColon: "Aktiv bis:", exploreCreators: "Ersteller entdecken", exploreCreatorsF: "Ersteller entdecken", subCount: "Abonnement", subsCount: "Abonnements", registeredSub: "registriert", registeredSubs: "registriert", premiumSubs: "Premium-Abonnement", premiumSubsPlural: "Premium-Abonnements", viewChat: "Chat anzeigen", view: "Ansehen" },
      chat: { send: "Senden", placeholder: "Schreibe deine Nachricht...", closed: "Chat geschlossen (Verlauf)", openChat: "Chat mit Ersteller öffnen", closeChat: "Chat schließen", title: "Chat mit Admin" },
      tipPage: { services: "Dienste", back: "Zurück", tip: "Trinkgeld senden", buy: "Kaufen", customAmount: "Benutzerdefinierter Betrag", links: "Links", liveNow: "Jetzt live", loading: "Wird geladen...", errorLoad: "Laden fehlgeschlagen", errorRequestChat: "Fehler beim Chat-Anfordern", errorSubscription: "Fehler beim Abonnement-Start", selectAmount: "Betrag auswählen", privateChannel: "Privater Kanal", publicChannel: "Öffentlicher Kanal", paymentCanceled: "Zahlung abgebrochen", payPrefix: "Zahlen", selectAmountFirst: "Betrag auswählen" },
      lang: { label: "Sprache", select: "Sprache wählen" },
      channel: {
        loadMore: "Weitere Nachrichten laden", noMessages: "Noch keine Beiträge.", firstPost: "Sei der Erste, der postet.",
        driveReconnectBanner: "Drive muss neu verbunden werden, um Bilder zu laden.", reconnectDrive: "Drive neu verbinden",
        driveActive: "Drive aktiv", connectDrive: "Drive verbinden", commentPlaceholder: "Kommentar schreiben",
        copy: "Kopieren", pin: "Anheften", unpin: "Lösen", edit: "Bearbeiten", delete: "Löschen",
        fanPreviewOn: "Fan-Vorschau", fanPreviewOff: "Vorschau beenden",
        hide: "Ausblenden", schedule: "Planen", cancelSchedule: "Planung abbrechen",
        linkCopied: "Link kopiert", channelNotFound: "Kanal nicht gefunden",
        requestSent: "Anfrage gesendet. Warte auf Genehmigung.", joined: "Du bist dem Kanal beigetreten",
        left: "Du hast den Kanal verlassen", deleted: "Kanal gelöscht",
        pinSuccess: "Nachricht angeheftet", unpinSuccess: "Nachricht gelöst", deleteSuccess: "Nachricht gelöscht",
        driveActivated: "Google Drive in diesem Kanal aktiviert.", driveDeactivated: "Google Drive in diesem Kanal deaktiviert.",
        publishScheduled: "Beitrag erfolgreich geplant",
        videoTrimmed: "Ihr Video war länger als 15 Sekunden und wurde automatisch gekürzt.",
        uploadSuccess: "Datei hochgeladen. Sie wird nach 15 Tagen automatisch gelöscht.",
        gifUploadSuccess: "GIF hochgeladen. Es wird nach 15 Tagen automatisch gelöscht.",
        driveUploadSuccess: "Datei auf Drive hochgeladen und bereit zur Veröffentlichung",
        gifUploading: "GIF wird hochgeladen...", videoProcessing: "Video wird verarbeitet...", imageUploading: "Bild wird hochgeladen...",
        errorEdit: "Bearbeitungsfehler", errorDelete: "Löschfehler", errorPin: "Anheftfehler",
        errorUpload: "Upload-Fehler", errorGifUpload: "GIF-Upload-Fehler", errorDriveUpload: "Drive-Upload-Fehler",
        errorPublish: "Veröffentlichungsfehler", errorBackground: "Hintergrund konnte nicht gespeichert werden",
        errorBubbleColor: "Blasenfarbe konnte nicht gespeichert werden",
        errorDriveConnect: "Drive-Verbindungsfehler. Versuche es in Premium-Inhalten.",
        driveReconnectNeeded: "Du musst Google Drive in PREMIUM-INHALTEN neu verbinden",
        onlyImagesVideos: "Nur Bilder und Videos sind erlaubt", onlyGif: "Nur GIF-Dateien sind erlaubt.",
      },
    },
  },

  /* ──────────────────────────────── ITALIANO ─────────────────────────────── */
  it: {
    translation: {
      STARTIP: "STARTIP",
      loading: "CARICAMENTO...",
      ageGate: {
        title: "Contenuto per adulti",
        subtitle: "Questo sito contiene contenuti esclusivi per adulti",
        confirm: "HO PIÙ DI 18 ANNI",
        deny: "Sono minorenne",
        warning: "Devi essere maggiorenne per accedere.",
        legal: "La conferma dell'età è di esclusiva responsabilità dell'utente. STARTIP non si assume alcuna responsabilità per dichiarazioni false.",
      },
      header: {
        login: "Accedi",
        logout: "Esci",
        myPanel: "Il mio pannello",
        myServices: "I miei servizi",
        chatAdmin: "Chat supporto",
        admin: "Admin",
      },
      hero: {
        title: "Fai brillare chi",
        titleHighlight: "ammiri",
        howItWorks: "Come funziona?",
        promotions: "Promozioni",
        privacyTitle: "L'arte di vendere, pagare e riscuotere con maggiore privacy",
        privacyText: "Sulla nostra piattaforma puoi ricevere ed effettuare pagamenti con un nome artistico o alias, senza rivelare la tua vera identità.\n\nNon devi condividere con l'acquirente il tuo IBAN né il tuo account PayPal personale, evitando di esporre dati privati e sensibili.\n\nTuteliamo anche la privacy di chi paga un venditore, consentendo che il suo profilo possa contenere un alias che non corrisponda al suo nome reale dopo un acquisto.\n\nIl nostro impegno è garantire che quando vendi e acquisti link esterni, l'anonimato e la riservatezza possano persistere per entrambe le parti.",
        searchPlaceholder: "Cerca venditore",
      },
      live: {
        liveNow: "IN DIRETTA ORA",
        badge: "IN DIRETTA",
        noLive: "Nessun creator è in diretta al momento.",
        showAll: "Mostra tutti i creator",
      },
      filters: {
        label: "Filtri",
        clearAll: "Cancella tutto",
        gender: "Sesso",
        all: "Tutti",
        women: "Donne",
        men: "Uomini",
        socialNetworks: "Social Network",
        webcamLive: "Webcam live",
      },
      cards: {
        updated: "Aggiornato",
        noModels: "Nessun modello disponibile al momento.",
        noResults: 'Nessun modello trovato per "{{search}}"',
      },
      pagination: { previous: "PRECEDENTE", next: "SUCCESSIVO" },
      footer: {
        legal: "Note legali",
        privacy: "Informativa sulla privacy",
        cookies: "Informativa sui cookie",
        contact: "Contatto",
      },
      chat: {
        title: "Chat supporto",
        placeholder: "Scrivi il tuo messaggio...",
        send: "Invia",
        noMessages: "Ancora nessun messaggio. Scrivici!",
      },
      auth: {
        login: "Accedi",
        register: "Crea account",
        email: "Email",
        password: "Password",
        name: "Nome",
        alreadyHaveAccount: "Hai già un account? Accedi",
        noAccount: "Non hai un account? Registrati",
        submitLogin: "Entra",
        submitRegister: "Registrati",
        chooseRole: "Scegli se sei fan o creator",
        fan: "Fan",
        creator: "Creator / Venditore",
        fanDescription: "Accedo alle chat private e acquisto contenuti",
        creatorDescription: "Pubblico servizi, ricevo mance e incasso",
        forgotPassword: "Password dimenticata?",
        resetSent: "Ti abbiamo inviato un'email di recupero",
        errorRole: "Scegli se sei fan o creator prima di continuare",
        accountCreated: "Account creato",
        successLogin: "Benvenuto/a!",
        orContinueWith: "Oppure continua con",
        googleLogin: "Continua con Google",
        fanDescriptionShort: "Seguo modelli e acquisto contenuti",
        creatorDescriptionShort: "Vendo contenuti e ricevo mance",
        hidePassword: "Nascondi password",
        showPassword: "Mostra password",
        accountCreatedLogin: "Account creato! Accesso in corso...",
        referralError: "Impossibile registrare il fan referente.",
        registerError: "Errore di registrazione",
        authBack: "← Indietro",
        namePlaceholderFan: "Il tuo nome o nickname",
        namePlaceholderCreator: "Nome pubblico",
        passwordPlaceholder: "Minimo 6 caratteri",
        inviterTitle: "Chi ti ha invitato? (opzionale)",
        inviterDescription: "Se un Fan VIP ti ha portato qui, scrivi il suo nome esatto. Altrimenti lascia vuoto.",
        inviterLabel: "Nome del Fan che ti ha invitato",
        inviterPlaceholder: "Nome esatto del fan...",
        consumerPrivacyNote: "Come consumatore, il tuo profilo è privato. Il tuo nome apparirà nelle chat dei servizi acquistati.",
      },
      common: {
        delete: "Elimina",
        cancel: "Annulla",
        confirm: "Conferma",
        back: "Indietro",
        error: "Errore",
        by: "di",
        explore: "Esplora",
        noCancel: "Mantieni",
        yes: "Sì",
        no: "No",
        send: "Invia richiesta",
      },
      install: {
        title: "Scarica l'app STARTIP",
        subtitle: "Installa l'app per un'esperienza migliore",
        install: "Installa",
        close: "Chiudi",
      },
      nav: { myPanel: "Il mio pannello", myServices: "I miei servizi", home: "Home", logout: "Esci", profile: "Il mio profilo", channels: "Canali", chats: "Chat", subscriptions: "Abbonamenti", premium: "Premium", services: "Servizi" },
      dashboard: { balance: "Saldo", tips: "Mance", services: "Servizi", withdrawals: "Prelievi", totalEarned: "Guadagnato", loading: "CARICAMENTO...", noTips: "Non hai ancora ricevuto mance", pendingVerification: "Il tuo profilo è in attesa di verifica.", pendingVerification2: "Il tuo profilo è in attesa di verifica.", withdraw: "Richiedi prelievo", withdrawAmount: "Importo da prelevare", errorLoading: "Errore caricamento dati", noMethod: "Nessun metodo di pagamento configurato.", noMethodDesc: "Vai al tuo profilo e scegli IBAN o PayPal.", configureInProfile: "Configura nel mio profilo →", withdrawAmountLabel: "Importo da prelevare", withdrawMin: "Minimo", withdrawAvailable: "Disponibile", withdrawAll: "Tutto", sendingRequest: "Invio richiesta...", confirmIbanWithdrawal: "Conferma richiesta prelievo IBAN", needMoreBalance: "Hai bisogno di almeno", toWithdraw: "per prelevare. Ti mancano", clientChats: "Chat clienti", withdrawalCompleted: "Completato", withdrawalPending: "In attesa", withdrawalShipped: "💸 Denaro in arrivo", withdrawalRejected: "Rifiutato", withdrawalFailed: "Fallito", withdrawIban: "Preleva su IBAN", withdrawPaypal: "Preleva su PayPal (+1€)", chatOpen: "Aperto", chatClosed: "Completato", chatNone: "Nessuna chat", viewChat: "Vedi chat", open: "Apri", view: "Vedi", newMessages: "nuovo", newMessagesPlural: "nuovi", noTipsYet: "Nessuna mancia ancora", withdrawalDeleted: "Prelievo eliminato", errorDeleteWithdrawal: "Errore eliminazione", chatDeletedDash: "Chat rimossa dalla lista", ibanDestination: "IBAN destinazione", accountHolderName: "Nome del titolare", ibanCountryCode: "Paese (codice ISO 2 lettere)", transferDetails: "Dettagli bonifico", requested: "Importo richiesto:", commission: "Commissione:", willReceiveBank: "Riceverai via banca:", willReceive: "Riceverai:", noFee: "Nessuna commissione (≥ 100 €)" },
      consumer: { title: "I miei servizi", noServices: "Non hai ancora acquistato nessun servizio.", explore: "Esplora i creatori", buyMore: "+ Acquista altri", configName: "Configura il tuo nome", promotionApplied: "Promozione applicata", validUntil: "Valido fino al", chatPending: "Chat in attesa di attivazione dal creatore", confirmDeleteChat: "Rimuovere questa chat? Azione irreversibile.", chatDeleted: "Chat rimossa dalla lista", errorDeleteChat: "Errore rimozione chat", subscriptionCanceled: "Abbonamento annullato.", subscriptionDeleted: "Abbonamento eliminato.", errorCancelSub: "Errore annullamento", errorDeleteSub: "Errore eliminazione", cancelSubConfirm: "Annullare l'abbonamento? Resterai attivo fino a fine periodo.", deleteSubConfirm: "Eliminare questo record? Non è reversibile.", noServices2: "Non hai ancora acquistato nessun servizio.", noSubs: "Nessun abbonamento attivo.", noPremium: "Nessun abbonamento premium", noPremiumDesc: "Accedi ai contenuti esclusivi Drive dei tuoi creatori preferiti.", configNameDesc: "I creatori ti vedranno come «Utente» finché non configuri il nome. Vai a", configNameCTA: "Il mio profilo", configNameSuffix: "per aggiungere il tuo nome.", privateChatDesc: "Richieste di chat privata inviate ai creatori", requestChat: "+ Richiedi chat", viewExclusiveContent: "Vedi contenuto esclusivo", renewAccess: "Rinnova accesso", requestReaccess: "Richiedi ri-accesso", reaccessPending: "Richiesta in attesa…", reaccessTitle: "Richiedi ri-accesso", reaccessDesc: "per recuperare l'accesso al contenuto esclusivo.", reaccessInfo: "Il creatore riceverà una notifica.", reaccessSent: "Richiesta inviata.", reaccessAlreadyPending: "Hai già una richiesta in attesa.", reaccessError: "Impossibile inviare la richiesta", sendRequest: "Invia richiesta", statusActive: "Attivo", statusTrialing: "Prova", statusPastDue: "Pagamento in attesa", statusCanceled: "Annullato", statusIncomplete: "Incompleto", statusExpired: "Scaduto", statusExpelled: "Espulso", plan: "Piano", paid: "Pagato", daysRemaining: "Rimanenti", expiredLabel: "Scaduto", accessUntil: "Accesso fino al", expiredOn: "Scaduto il", cancelAtPeriodEnd: "(annulla a fine periodo)", nextRenewal: "Prossimo rinnovo:", activeUntilColon: "Attivo fino al:", exploreCreators: "Esplora i creatori", exploreCreatorsF: "Esplora i creatori", subCount: "abbonamento", subsCount: "abbonamenti", registeredSub: "registrato", registeredSubs: "registrati", premiumSubs: "abbonamento premium", premiumSubsPlural: "abbonamenti premium", viewChat: "Vedi chat", view: "Vedi" },
      chat: { send: "Invia", placeholder: "Scrivi il tuo messaggio...", closed: "Chat chiusa (cronologia)", openChat: "Apri chat con il creatore", closeChat: "Chiudi chat", title: "Chat con admin" },
      tipPage: { services: "Servizi", back: "Indietro", tip: "Invia mancia", buy: "Acquista", customAmount: "Importo personalizzato", links: "Link", liveNow: "In diretta", loading: "Caricamento...", errorLoad: "Impossibile caricare", errorRequestChat: "Errore richiesta chat", errorSubscription: "Errore avvio abbonamento", selectAmount: "Seleziona un importo", privateChannel: "Canale privato", publicChannel: "Canale pubblico", paymentCanceled: "Pagamento annullato", payPrefix: "Paga", selectAmountFirst: "Seleziona un importo" },
      lang: { label: "Lingua", select: "Seleziona lingua" },
      channel: {
        loadMore: "Carica altri messaggi", noMessages: "Nessuna pubblicazione ancora.", firstPost: "Sii il primo a pubblicare.",
        driveReconnectBanner: "Il tuo Drive ha bisogno di riconnessione per caricare immagini.", reconnectDrive: "Riconnetti Drive",
        driveActive: "Drive attivo", connectDrive: "Connetti Drive", commentPlaceholder: "Scrivi un commento",
        copy: "Copia", pin: "Fissa", unpin: "Slega", edit: "Modifica", delete: "Elimina",
        fanPreviewOn: "Anteprima fan", fanPreviewOff: "Esci dall'anteprima",
        hide: "Nascondi", schedule: "Pianifica", cancelSchedule: "Annulla pianificazione",
        linkCopied: "Link copiato", channelNotFound: "Canale non trovato",
        requestSent: "Richiesta inviata. In attesa di approvazione.", joined: "Hai aderito al canale",
        left: "Hai lasciato il canale", deleted: "Canale eliminato",
        pinSuccess: "Messaggio fissato", unpinSuccess: "Messaggio slegate", deleteSuccess: "Messaggio eliminato",
        driveActivated: "Google Drive attivato in questo canale.", driveDeactivated: "Google Drive disattivato in questo canale.",
        publishScheduled: "Pubblicazione pianificata con successo",
        videoTrimmed: "Il tuo video era più lungo di 15 secondi ed è stato tagliato automaticamente.",
        uploadSuccess: "File caricato. Verrà eliminato automaticamente dopo 15 giorni.",
        gifUploadSuccess: "GIF caricato. Verrà eliminato automaticamente dopo 15 giorni.",
        driveUploadSuccess: "File caricato su Drive e pronto per la pubblicazione",
        gifUploading: "Caricamento GIF...", videoProcessing: "Elaborazione video...", imageUploading: "Caricamento immagine...",
        errorEdit: "Errore di modifica", errorDelete: "Errore di eliminazione", errorPin: "Errore di fissaggio",
        errorUpload: "Errore di caricamento", errorGifUpload: "Errore GIF", errorDriveUpload: "Errore Drive",
        errorPublish: "Errore di pubblicazione", errorBackground: "Impossibile salvare lo sfondo",
        errorBubbleColor: "Impossibile salvare il colore",
        errorDriveConnect: "Errore Drive. Riprova da Contenuto Premium.",
        driveReconnectNeeded: "Devi riconnettere Google Drive in CONTENUTO PREMIUM",
        onlyImagesVideos: "Sono consentite solo immagini e video", onlyGif: "Sono consentiti solo file GIF.",
      },
    },
  },

  /* ──────────────────────────────── PORTUGUÊS ────────────────────────────── */
  pt: {
    translation: {
      STARTIP: "STARTIP",
      loading: "CARREGANDO...",
      ageGate: {
        title: "Conteúdo para adultos",
        subtitle: "Este site contém conteúdo exclusivo para adultos",
        confirm: "TENHO MAIS DE 18 ANOS",
        deny: "Sou menor de idade",
        warning: "Você deve ter idade legal para acessar.",
        legal: "A confirmação da maioridade é de responsabilidade exclusiva do utilizador. STARTIP não assume qualquer responsabilidade por declarações falsas.",
      },
      header: {
        login: "Entrar",
        logout: "Sair",
        myPanel: "Meu painel",
        myServices: "Meus serviços",
        chatAdmin: "Chat suporte",
        admin: "Admin",
      },
      hero: {
        title: "Faça brilhar quem você",
        titleHighlight: "admira",
        howItWorks: "Como funciona?",
        promotions: "Promoções",
        privacyTitle: "A arte de vender, pagar e cobrar com maior privacidade",
        privacyText: "Em nossa plataforma, você pode receber e realizar pagamentos com um nome artístico ou apelido, sem revelar sua identidade real.\n\nVocê não precisa compartilhar seu IBAN nem sua conta PayPal pessoal com o comprador, evitando expor dados privados e sensíveis.\n\nTambém protegemos a privacidade de quem paga a um vendedor, permitindo que seu perfil contenha um apelido que não corresponda ao seu nome real após uma compra.\n\nNosso compromisso é garantir que, ao vender e comprar links externos, o anonimato e a confidencialidade possam existir para ambas as partes.",
        searchPlaceholder: "Buscar modelo",
      },
      live: {
        liveNow: "AO VIVO AGORA",
        badge: "AO VIVO",
        noLive: "Nenhum criador está ao vivo no momento.",
        showAll: "Ver todos os criadores",
      },
      filters: {
        label: "Filtros",
        clearAll: "Limpar tudo",
        gender: "Gênero",
        all: "Todos",
        women: "Mulheres",
        men: "Homens",
        socialNetworks: "Redes Sociais",
        webcamLive: "Webcam ao vivo",
      },
      cards: {
        updated: "Atualizado",
        noModels: "Sem modelos disponíveis ainda.",
        noResults: 'Nenhum modelo encontrado para "{{search}}"',
      },
      pagination: { previous: "ANTERIOR", next: "PRÓXIMO" },
      footer: {
        legal: "Aviso legal",
        privacy: "Política de privacidade",
        cookies: "Política de cookies",
        contact: "Contacto",
      },
      chat: {
        title: "Chat suporte",
        placeholder: "Escreva sua mensagem...",
        send: "Enviar",
        noMessages: "Sem mensagens ainda. Escreva-nos!",
      },
      auth: {
        login: "Entrar",
        register: "Criar conta",
        email: "Email",
        password: "Senha",
        name: "Nome",
        alreadyHaveAccount: "Já tem uma conta? Entre",
        noAccount: "Não tem conta? Registre-se",
        submitLogin: "Entrar",
        submitRegister: "Registrar",
        chooseRole: "Escolha se você é fã ou criador",
        fan: "Fã",
        creator: "Criador / Vendedor",
        fanDescription: "Acedo a chats privados e compro conteúdo",
        creatorDescription: "Publico serviços, recebo gorjetas e cobro",
        forgotPassword: "Esqueceu a senha?",
        resetSent: "Enviamos um e-mail de recuperação",
        errorRole: "Escolha se você é fã ou criador antes de continuar",
        accountCreated: "Conta criada",
        successLogin: "Bem-vindo/a!",
        orContinueWith: "Ou continuar com",
        googleLogin: "Continuar com Google",
        fanDescriptionShort: "Sigo modelos e compro conteúdo",
        creatorDescriptionShort: "Vendo conteúdo e recebo gorjetas",
        hidePassword: "Ocultar senha",
        showPassword: "Mostrar senha",
        accountCreatedLogin: "Conta criada! Entrando...",
        referralError: "Não foi possível registrar o fã indicador.",
        registerError: "Erro ao registrar",
        authBack: "← Voltar",
        namePlaceholderFan: "Seu nome ou apelido",
        namePlaceholderCreator: "Nome público",
        passwordPlaceholder: "Mínimo 6 caracteres",
        inviterTitle: "Quem te convidou? (opcional)",
        inviterDescription: "Se um Fã VIP te trouxe aqui, escreva o nome exato. Caso contrário, deixe em branco.",
        inviterLabel: "Nome do Fã que te convidou",
        inviterPlaceholder: "Nome exato do fã...",
        consumerPrivacyNote: "Como consumidor, seu perfil é privado. Seu nome aparecerá nos chats dos serviços contratados.",
      },
      common: {
        delete: "Excluir",
        cancel: "Cancelar",
        confirm: "Confirmar",
        back: "Voltar",
        error: "Erro",
        by: "por",
        explore: "Explorar",
        noCancel: "Manter",
        yes: "Sim",
        no: "Não",
        send: "Enviar solicitação",
      },
      install: {
        title: "Baixar app STARTIP",
        subtitle: "Instale o app para uma melhor experiência",
        install: "Instalar",
        close: "Fechar",
      },
      nav: { myPanel: "Meu painel", myServices: "Meus serviços", home: "Início", logout: "Sair", profile: "Meu perfil", channels: "Canais", chats: "Chats", subscriptions: "Assinaturas", premium: "Premium", services: "Serviços" },
      dashboard: { balance: "Saldo", tips: "Gorjetas", services: "Serviços", withdrawals: "Saques", totalEarned: "Ganho", loading: "CARREGANDO...", noTips: "Você ainda não recebeu gorjetas", pendingVerification: "Seu perfil está pendente de verificação.", pendingVerification2: "Seu perfil está pendente de verificação.", withdraw: "Solicitar saque", withdrawAmount: "Valor a sacar", errorLoading: "Erro ao carregar dados", noMethod: "Nenhum método de pagamento configurado.", noMethodDesc: "Vá ao seu perfil e escolha IBAN ou PayPal.", configureInProfile: "Configurar em meu perfil →", withdrawAmountLabel: "Valor a sacar", withdrawMin: "Mínimo", withdrawAvailable: "Disponível", withdrawAll: "Tudo", sendingRequest: "Enviando solicitação...", confirmIbanWithdrawal: "Confirmar solicitação de saque IBAN", needMoreBalance: "Você precisa de pelo menos", toWithdraw: "para sacar. Faltam", clientChats: "Chats de clientes", withdrawalCompleted: "Concluído", withdrawalPending: "Pendente", withdrawalShipped: "💸 Dinheiro a caminho", withdrawalRejected: "Rejeitado", withdrawalFailed: "Falhou", withdrawIban: "Sacar para IBAN", withdrawPaypal: "Sacar para PayPal (+1€)", chatOpen: "Aberto", chatClosed: "Concluído", chatNone: "Sem chat", viewChat: "Ver chat", open: "Abrir", view: "Ver", newMessages: "novo", newMessagesPlural: "novos", noTipsYet: "Sem gorjetas ainda", withdrawalDeleted: "Saque excluído", errorDeleteWithdrawal: "Erro ao excluir", chatDeletedDash: "Chat removido da lista", ibanDestination: "IBAN destino", accountHolderName: "Nome do titular", ibanCountryCode: "País (código ISO 2 letras)", transferDetails: "Detalhes da transferência", requested: "Valor solicitado:", commission: "Comissão:", willReceiveBank: "Você receberá por banco:", willReceive: "Você receberá:", noFee: "Sem comissão (≥ 100 €)" },
      consumer: { title: "Meus Serviços", noServices: "Você ainda não contratou nenhum serviço.", explore: "Explorar criadores", buyMore: "+ Contratar mais", configName: "Configure seu nome", promotionApplied: "Promoção aplicada", validUntil: "Válido até", chatPending: "Chat aguardando ativação pelo criador", confirmDeleteChat: "Remover este chat da lista? Ação irreversível.", chatDeleted: "Chat removido da lista", errorDeleteChat: "Erro ao remover chat", subscriptionCanceled: "Assinatura cancelada.", subscriptionDeleted: "Assinatura excluída.", errorCancelSub: "Erro ao cancelar", errorDeleteSub: "Erro ao excluir", cancelSubConfirm: "Cancelar assinatura? Você ficará ativo até o fim do período.", deleteSubConfirm: "Excluir este registro? Não pode ser desfeito.", noServices2: "Você ainda não contratou nenhum serviço.", noSubs: "Sem assinaturas ativas.", noPremium: "Sem assinaturas premium", noPremiumDesc: "Acesse conteúdo exclusivo Drive de seus criadores favoritos.", configNameDesc: "Os criadores te verão como «Usuário» até você configurar seu nome. Vá para", configNameCTA: "Meu Perfil", configNameSuffix: "para adicionar seu nome.", privateChatDesc: "Solicitações de chat privado enviadas a criadores", requestChat: "+ Solicitar chat", viewExclusiveContent: "Ver conteúdo exclusivo", renewAccess: "Renovar acesso", requestReaccess: "Solicitar re-acesso", reaccessPending: "Solicitação pendente…", reaccessTitle: "Solicitar re-acesso", reaccessDesc: "para recuperar acesso ao conteúdo exclusivo.", reaccessInfo: "O criador receberá uma notificação.", reaccessSent: "Solicitação enviada.", reaccessAlreadyPending: "Já há uma solicitação pendente.", reaccessError: "Não foi possível enviar a solicitação", sendRequest: "Enviar solicitação", statusActive: "Ativa", statusTrialing: "Período de teste", statusPastDue: "Pagamento pendente", statusCanceled: "Cancelada", statusIncomplete: "Incompleta", statusExpired: "Expirada", statusExpelled: "Expulso", plan: "Plano", paid: "Pago", daysRemaining: "Restantes", expiredLabel: "Expirou", accessUntil: "Acesso até", expiredOn: "Expirou em", cancelAtPeriodEnd: "(cancela no final do período)", nextRenewal: "Próxima renovação:", activeUntilColon: "Ativa até:", exploreCreators: "Explorar criadores", exploreCreatorsF: "Explorar criadores", subCount: "assinatura", subsCount: "assinaturas", registeredSub: "registrada", registeredSubs: "registradas", premiumSubs: "assinatura premium", premiumSubsPlural: "assinaturas premium", viewChat: "Ver chat", view: "Ver" },
      chat: { send: "Enviar", placeholder: "Escreva sua mensagem...", closed: "Chat fechado (histórico)", openChat: "Abrir chat com o criador", closeChat: "Fechar chat", title: "Chat com admin" },
      tipPage: { services: "Serviços", back: "Voltar", tip: "Enviar gorjeta", buy: "Comprar", customAmount: "Valor personalizado", links: "Links", liveNow: "Ao vivo", loading: "Carregando...", errorLoad: "Não foi possível carregar", errorRequestChat: "Erro ao solicitar chat", errorSubscription: "Erro ao iniciar assinatura", selectAmount: "Selecione um valor", privateChannel: "Canal privado", publicChannel: "Canal público", paymentCanceled: "Pagamento cancelado", payPrefix: "Pagar", selectAmountFirst: "Selecione um valor" },
      lang: { label: "Idioma", select: "Selecionar idioma" },
      channel: {
        loadMore: "Carregar mais mensagens", noMessages: "Sem publicações ainda.", firstPost: "Seja o primeiro a publicar.",
        driveReconnectBanner: "Seu Drive precisa de reconexão para carregar imagens.", reconnectDrive: "Reconectar Drive",
        driveActive: "Drive ativo", connectDrive: "Conectar Drive", commentPlaceholder: "Escreva um comentário",
        copy: "Copiar", pin: "Fixar", unpin: "Desafixar", edit: "Editar", delete: "Excluir",
        fanPreviewOn: "Pré-visualização de fã", fanPreviewOff: "Sair da pré-visualização",
        hide: "Ocultar", schedule: "Agendar", cancelSchedule: "Cancelar agendamento",
        linkCopied: "Link copiado", channelNotFound: "Canal não encontrado",
        requestSent: "Solicitação enviada. Aguardando aprovação.", joined: "Você entrou no canal",
        left: "Você saiu do canal", deleted: "Canal excluído",
        pinSuccess: "Mensagem fixada", unpinSuccess: "Mensagem desafixada", deleteSuccess: "Mensagem excluída",
        driveActivated: "Google Drive ativado neste canal.", driveDeactivated: "Google Drive desativado neste canal.",
        publishScheduled: "Publicação agendada com sucesso",
        videoTrimmed: "Seu vídeo era mais longo que 15 segundos e foi cortado automaticamente.",
        uploadSuccess: "Arquivo enviado. Será excluído automaticamente em 15 dias.",
        gifUploadSuccess: "GIF enviado. Será excluído automaticamente em 15 dias.",
        driveUploadSuccess: "Arquivo enviado ao Drive e pronto para publicar",
        gifUploading: "Enviando GIF...", videoProcessing: "Processando vídeo...", imageUploading: "Enviando imagem...",
        errorEdit: "Erro ao editar", errorDelete: "Erro ao excluir", errorPin: "Erro ao fixar",
        errorUpload: "Erro ao enviar arquivo", errorGifUpload: "Erro ao enviar GIF", errorDriveUpload: "Erro ao enviar para Drive",
        errorPublish: "Erro ao publicar", errorBackground: "Não foi possível salvar o fundo",
        errorBubbleColor: "Não foi possível salvar a cor",
        errorDriveConnect: "Erro ao conectar Drive. Tente pelo Conteúdo Premium.",
        driveReconnectNeeded: "Você precisa reconectar o Google Drive no CONTEÚDO PREMIUM",
        onlyImagesVideos: "Somente imagens e vídeos são permitidos", onlyGif: "Somente arquivos GIF são permitidos.",
      },
    },
  },

  /* ──────────────────────────────── NEDERLANDS ───────────────────────────── */
  nl: {
    translation: {
      STARTIP: "STARTIP",
      loading: "LADEN...",
      ageGate: {
        title: "Inhoud voor volwassenen",
        subtitle: "Deze site bevat exclusieve inhoud voor volwassenen",
        confirm: "IK BEN OUDER DAN 18",
        deny: "Ik ben minderjarig",
        warning: "U moet meerderjarig zijn om toegang te krijgen.",
        legal: "De leeftijdsbevestiging is de uitsluitende verantwoordelijkheid van de gebruiker. STARTIP aanvaardt geen aansprakelijkheid voor valse verklaringen.",
      },
      header: {
        login: "Inloggen",
        logout: "Uitloggen",
        myPanel: "Mijn paneel",
        myServices: "Mijn diensten",
        chatAdmin: "Ondersteuningschat",
        admin: "Admin",
      },
      hero: {
        title: "Laat diegene stralen die jij",
        titleHighlight: "bewondert",
        howItWorks: "Hoe werkt het?",
        promotions: "Promoties",
        privacyTitle: "De kunst van verkopen, betalen en innen met meer privacy",
        privacyText: "Op ons platform kun je betalingen ontvangen en doen onder een artiestennaam of alias, zonder je echte identiteit te onthullen.\n\nJe hoeft je IBAN of persoonlijke PayPal-account niet met de koper te delen, waardoor je privégegevens niet worden blootgesteld.\n\nWe beschermen ook de privacy van degenen die een verkoper betalen, zodat hun profiel een alias kan bevatten die niet overeenkomt met hun echte naam na een aankoop.\n\nOnze inzet is ervoor te zorgen dat bij het kopen en verkopen van externe links, anonimiteit en vertrouwelijkheid voor beide partijen kunnen blijven bestaan.",
        searchPlaceholder: "Zoek verkoper",
      },
      live: {
        liveNow: "NU LIVE",
        badge: "LIVE",
        noLive: "Er is momenteel geen creator live.",
        showAll: "Alle creators bekijken",
      },
      filters: {
        label: "Filters",
        clearAll: "Alles wissen",
        gender: "Geslacht",
        all: "Alle",
        women: "Vrouwen",
        men: "Mannen",
        socialNetworks: "Sociale netwerken",
        webcamLive: "Webcam live",
      },
      cards: {
        updated: "Bijgewerkt",
        noModels: "Nog geen modellen beschikbaar.",
        noResults: 'Geen modellen gevonden voor "{{search}}"',
      },
      pagination: { previous: "VORIGE", next: "VOLGENDE" },
      footer: {
        legal: "Juridische kennisgeving",
        privacy: "Privacybeleid",
        cookies: "Cookiebeleid",
        contact: "Contact",
      },
      chat: {
        title: "Ondersteuningschat",
        placeholder: "Typ je bericht...",
        send: "Verzenden",
        noMessages: "Nog geen berichten. Schrijf ons!",
      },
      auth: {
        login: "Inloggen",
        register: "Account aanmaken",
        email: "E-mail",
        password: "Wachtwoord",
        name: "Naam",
        alreadyHaveAccount: "Heb je al een account? Inloggen",
        noAccount: "Geen account? Registreren",
        submitLogin: "Inloggen",
        submitRegister: "Registreren",
        chooseRole: "Kies of je een fan of creator bent",
        fan: "Fan",
        creator: "Creator / Verkoper",
        fanDescription: "Ik heb toegang tot privéchats en koop inhoud",
        creatorDescription: "Ik publiceer diensten, ontvang fooien en int betalingen",
        forgotPassword: "Wachtwoord vergeten?",
        resetSent: "We hebben je een herstel-e-mail gestuurd",
        errorRole: "Kies fan of creator voor je doorgaat",
        accountCreated: "Account aangemaakt",
        successLogin: "Welkom!",
        orContinueWith: "Of ga verder met",
        googleLogin: "Doorgaan met Google",
        fanDescriptionShort: "Ik volg modellen en koop inhoud",
        creatorDescriptionShort: "Ik verkoop inhoud en ontvang fooien",
        hidePassword: "Wachtwoord verbergen",
        showPassword: "Wachtwoord tonen",
        accountCreatedLogin: "Account aangemaakt! Inloggen...",
        referralError: "Fan-verwijzing kon niet worden geregistreerd.",
        registerError: "Registratiefout",
        authBack: "← Terug",
        namePlaceholderFan: "Uw naam of bijnaam",
        namePlaceholderCreator: "Publieke naam",
        passwordPlaceholder: "Minimaal 6 tekens",
        inviterTitle: "Wie heeft u uitgenodigd? (optioneel)",
        inviterDescription: "Als een VIP-fan u hierheen heeft gebracht, schrijf dan hun exacte naam. Anders leeg laten.",
        inviterLabel: "Naam van de fan die u uitnodigde",
        inviterPlaceholder: "Exacte naam van de fan...",
        consumerPrivacyNote: "Als consument is uw profiel privé. Uw naam verschijnt in de chats van de afgesloten diensten.",
      },
      common: {
        delete: "Verwijderen",
        cancel: "Annuleren",
        confirm: "Bevestigen",
        back: "Terug",
        error: "Fout",
        by: "door",
        explore: "Verkennen",
        noCancel: "Behouden",
        yes: "Ja",
        no: "Nee",
        send: "Verzoek versturen",
      },
      install: {
        title: "STARTIP app downloaden",
        subtitle: "Installeer de app voor een betere ervaring",
        install: "Installeren",
        close: "Sluiten",
      },
      nav: { myPanel: "Mijn panel", myServices: "Mijn diensten", home: "Home", logout: "Uitloggen", profile: "Mijn profiel", channels: "Kanalen", chats: "Chats", subscriptions: "Abonnementen", premium: "Premium", services: "Diensten" },
      dashboard: { balance: "Saldo", tips: "Fooien", services: "Diensten", withdrawals: "Opnames", totalEarned: "Verdiend", loading: "LADEN...", noTips: "U heeft nog geen fooien ontvangen", pendingVerification: "Uw profiel wacht op verificatie.", pendingVerification2: "Uw profiel wacht op verificatie.", withdraw: "Opname aanvragen", withdrawAmount: "Op te nemen bedrag", errorLoading: "Fout bij laden", noMethod: "Geen uitbetalingsmethode geconfigureerd.", noMethodDesc: "Ga naar uw profiel en kies IBAN of PayPal.", configureInProfile: "Instellen in mijn profiel →", withdrawAmountLabel: "Op te nemen bedrag", withdrawMin: "Minimum", withdrawAvailable: "Beschikbaar", withdrawAll: "Alles", sendingRequest: "Verzoek versturen...", confirmIbanWithdrawal: "IBAN-opname bevestigen", needMoreBalance: "U heeft minimaal", toWithdraw: "nodig. U mist nog", clientChats: "Klantenchats", withdrawalCompleted: "Voltooid", withdrawalPending: "In behandeling", withdrawalShipped: "💸 Geld onderweg", withdrawalRejected: "Afgewezen", withdrawalFailed: "Mislukt", withdrawIban: "Opnemen naar IBAN", withdrawPaypal: "Opnemen naar PayPal (+1€)", chatOpen: "Open", chatClosed: "Voltooid", chatNone: "Geen chat", viewChat: "Chat bekijken", open: "Openen", view: "Bekijken", newMessages: "nieuw", newMessagesPlural: "nieuwe", noTipsYet: "Nog geen fooien", withdrawalDeleted: "Opname verwijderd", errorDeleteWithdrawal: "Fout bij verwijderen", chatDeletedDash: "Chat van uw lijst verwijderd", ibanDestination: "Doel-IBAN", accountHolderName: "Naam rekeninghouder", ibanCountryCode: "Land (2-letter ISO-code)", transferDetails: "Overboekingsdetails", requested: "Aangevraagd:", commission: "Provisie:", willReceiveBank: "U ontvangt via bank:", willReceive: "U ontvangt:", noFee: "Geen provisie (≥ 100 €)" },
      consumer: { title: "Mijn Diensten", noServices: "U heeft nog geen dienst afgenomen.", explore: "Ontdek makers", buyMore: "+ Meer kopen", configName: "Stel uw naam in", promotionApplied: "Promotie toegepast", validUntil: "Geldig tot", chatPending: "Chat wacht op activering door maker", confirmDeleteChat: "Deze chat verwijderen? Onomkeerbare actie.", chatDeleted: "Chat van lijst verwijderd", errorDeleteChat: "Fout bij verwijderen chat", subscriptionCanceled: "Abonnement geannuleerd.", subscriptionDeleted: "Abonnement verwijderd.", errorCancelSub: "Fout bij annuleren", errorDeleteSub: "Fout bij verwijderen", cancelSubConfirm: "Abonnement annuleren? U blijft actief tot einde periode.", deleteSubConfirm: "Record verwijderen? Niet ongedaan te maken.", noServices2: "U heeft nog geen dienst afgenomen.", noSubs: "Geen actieve abonnementen.", noPremium: "Geen premium abonnementen", noPremiumDesc: "Toegang tot exclusieve Drive-inhoud van uw favoriete makers.", configNameDesc: "Makers zien u als «Gebruiker» totdat u uw naam instelt. Ga naar", configNameCTA: "Mijn Profiel", configNameSuffix: "om uw naam toe te voegen.", privateChatDesc: "Privéchatverzoeken die u naar makers heeft gestuurd", requestChat: "+ Chat aanvragen", viewExclusiveContent: "Exclusieve inhoud bekijken", renewAccess: "Toegang vernieuwen", requestReaccess: "Hertoegang aanvragen", reaccessPending: "Verzoek in behandeling…", reaccessTitle: "Hertoegang aanvragen", reaccessDesc: "om toegang tot exclusieve inhoud te herstellen.", reaccessInfo: "De maker ontvangt een melding.", reaccessSent: "Verzoek verzonden.", reaccessAlreadyPending: "Er is al een verzoek in behandeling.", reaccessError: "Verzoek kon niet worden verstuurd", sendRequest: "Verzoek versturen", statusActive: "Actief", statusTrialing: "Proef", statusPastDue: "Betaling uitstaand", statusCanceled: "Geannuleerd", statusIncomplete: "Onvolledig", statusExpired: "Verlopen", statusExpelled: "Verwijderd", plan: "Plan", paid: "Betaald", daysRemaining: "Resterend", expiredLabel: "Verlopen", accessUntil: "Toegang tot", expiredOn: "Verlopen op", cancelAtPeriodEnd: "(annuleert einde periode)", nextRenewal: "Volgende verlenging:", activeUntilColon: "Actief tot:", exploreCreators: "Ontdek makers", exploreCreatorsF: "Ontdek makers", subCount: "abonnement", subsCount: "abonnementen", registeredSub: "geregistreerd", registeredSubs: "geregistreerd", premiumSubs: "premium abonnement", premiumSubsPlural: "premium abonnementen", viewChat: "Chat bekijken", view: "Bekijken" },
      chat: { send: "Versturen", placeholder: "Schrijf uw bericht...", closed: "Chat gesloten (geschiedenis)", openChat: "Chat openen met maker", closeChat: "Chat sluiten", title: "Chat met admin" },
      tipPage: { services: "Diensten", back: "Terug", tip: "Fooi sturen", buy: "Kopen", customAmount: "Aangepast bedrag", links: "Links", liveNow: "Nu live", loading: "Laden...", errorLoad: "Laden mislukt", errorRequestChat: "Fout bij chatverzoek", errorSubscription: "Fout bij starten abonnement", selectAmount: "Selecteer een bedrag", privateChannel: "Privékanaal", publicChannel: "Openbaar kanaal", paymentCanceled: "Betaling geannuleerd", payPrefix: "Betalen", selectAmountFirst: "Selecteer een bedrag" },
      lang: { label: "Taal", select: "Taal selecteren" },
      channel: {
        loadMore: "Meer berichten laden", noMessages: "Nog geen berichten.", firstPost: "Wees de eerste om te plaatsen.",
        driveReconnectBanner: "Uw Drive moet opnieuw worden verbonden om afbeeldingen te laden.", reconnectDrive: "Drive opnieuw verbinden",
        driveActive: "Drive actief", connectDrive: "Drive verbinden", commentPlaceholder: "Schrijf een reactie",
        copy: "Kopiëren", pin: "Vastzetten", unpin: "Losmaken", edit: "Bewerken", delete: "Verwijderen",
        fanPreviewOn: "Fan-preview", fanPreviewOff: "Preview verlaten",
        hide: "Verbergen", schedule: "Plannen", cancelSchedule: "Planning annuleren",
        linkCopied: "Link gekopieerd", channelNotFound: "Kanaal niet gevonden",
        requestSent: "Verzoek verzonden. Wacht op goedkeuring.", joined: "U heeft het kanaal betreden",
        left: "U heeft het kanaal verlaten", deleted: "Kanaal verwijderd",
        pinSuccess: "Bericht vastgezet", unpinSuccess: "Bericht losgemaakt", deleteSuccess: "Bericht verwijderd",
        driveActivated: "Google Drive geactiveerd in dit kanaal.", driveDeactivated: "Google Drive gedeactiveerd in dit kanaal.",
        publishScheduled: "Bericht succesvol gepland",
        videoTrimmed: "Uw video was langer dan 15 seconden en werd automatisch ingekort.",
        uploadSuccess: "Bestand geüpload. Het wordt na 15 dagen automatisch verwijderd.",
        gifUploadSuccess: "GIF geüpload. Het wordt na 15 dagen automatisch verwijderd.",
        driveUploadSuccess: "Bestand geüpload naar Drive en klaar om te publiceren",
        gifUploading: "GIF uploaden...", videoProcessing: "Video verwerken...", imageUploading: "Afbeelding uploaden...",
        errorEdit: "Bewerkingsfout", errorDelete: "Verwijderingsfout", errorPin: "Vastzetfout",
        errorUpload: "Upload fout", errorGifUpload: "GIF upload fout", errorDriveUpload: "Drive upload fout",
        errorPublish: "Publicatiefout", errorBackground: "Achtergrond kon niet worden opgeslagen",
        errorBubbleColor: "Belkleur kon niet worden opgeslagen",
        errorDriveConnect: "Drive verbindingsfout. Probeer via Premium Content.",
        driveReconnectNeeded: "U moet Google Drive opnieuw verbinden in PREMIUM CONTENT",
        onlyImagesVideos: "Alleen afbeeldingen en video's zijn toegestaan", onlyGif: "Alleen GIF-bestanden zijn toegestaan.",
      },
    },
  },

  /* ──────────────────────────────── POLSKI ───────────────────────────────── */
  pl: {
    translation: {
      STARTIP: "STARTIP",
      loading: "ŁADOWANIE...",
      ageGate: {
        title: "Treści dla dorosłych",
        subtitle: "Ta strona zawiera ekskluzywne treści dla dorosłych",
        confirm: "MASZ PONAD 18 LAT",
        deny: "Jestem niepełnoletni",
        warning: "Musisz być pełnoletni, aby uzyskać dostęp.",
        legal: "Potwierdzenie pełnoletności jest wyłączną odpowiedzialnością użytkownika. STARTIP nie ponosi żadnej odpowiedzialności za fałszywe oświadczenia.",
      },
      header: {
        login: "Zaloguj się",
        logout: "Wyloguj się",
        myPanel: "Mój panel",
        myServices: "Moje usługi",
        chatAdmin: "Czat wsparcia",
        admin: "Admin",
      },
      hero: {
        title: "Spraw, aby zaświeciły osoby, które",
        titleHighlight: "podziwiasz",
        howItWorks: "Jak to działa?",
        promotions: "Promocje",
        privacyTitle: "Sztuka sprzedawania, płacenia i pobierania z większą prywatnością",
        privacyText: "Na naszej platformie możesz odbierać i dokonywać płatności pod pseudonimem artystycznym, bez ujawniania swojej prawdziwej tożsamości.\n\nNie musisz udostępniać kupującemu swojego numeru IBAN ani osobistego konta PayPal, unikając ujawniania prywatnych danych.\n\nChronimi również prywatność osób płacących sprzedawcy, umożliwiając, aby ich profil zawierał pseudonim nieodpowiadający ich prawdziwemu imieniu po zakupie.\n\nNaszym celem jest zapewnienie, że przy sprzedaży i zakupie zewnętrznych linków anonimowość i poufność mogą być zachowane dla obu stron.",
        searchPlaceholder: "Szukaj sprzedawcy",
      },
      live: {
        liveNow: "NA ŻYWO TERAZ",
        badge: "NA ŻYWO",
        noLive: "Żaden twórca nie jest teraz na żywo.",
        showAll: "Zobacz wszystkich twórców",
      },
      filters: {
        label: "Filtry",
        clearAll: "Wyczyść wszystko",
        gender: "Płeć",
        all: "Wszyscy",
        women: "Kobiety",
        men: "Mężczyźni",
        socialNetworks: "Sieci społecznościowe",
        webcamLive: "Kamera na żywo",
      },
      cards: {
        updated: "Zaktualizowano",
        noModels: "Brak dostępnych modeli.",
        noResults: 'Nie znaleziono modeli dla "{{search}}"',
      },
      pagination: { previous: "POPRZEDNIA", next: "NASTĘPNA" },
      footer: {
        legal: "Informacje prawne",
        privacy: "Polityka prywatności",
        cookies: "Polityka plików cookie",
        contact: "Kontakt",
      },
      chat: {
        title: "Czat wsparcia",
        placeholder: "Wpisz swoją wiadomość...",
        send: "Wyślij",
        noMessages: "Brak wiadomości. Napisz do nas!",
      },
      auth: {
        login: "Zaloguj się",
        register: "Utwórz konto",
        email: "Email",
        password: "Hasło",
        name: "Imię",
        alreadyHaveAccount: "Masz już konto? Zaloguj się",
        noAccount: "Nie masz konta? Zarejestruj się",
        submitLogin: "Wejdź",
        submitRegister: "Zarejestruj się",
        chooseRole: "Wybierz, czy jesteś fanem, czy twórcą",
        fan: "Fan",
        creator: "Twórca / Sprzedawca",
        fanDescription: "Mam dostęp do prywatnych czatów i kupuję treści",
        creatorDescription: "Publikuję usługi, otrzymuję napiwki i zbieram płatności",
        forgotPassword: "Zapomniałeś hasła?",
        resetSent: "Wysłaliśmy Ci e-mail odzyskiwania",
        errorRole: "Wybierz, czy jesteś fanem lub twórcą przed kontynuowaniem",
        accountCreated: "Konto utworzone",
        successLogin: "Witaj!",
        orContinueWith: "Lub kontynuuj z",
        googleLogin: "Kontynuuj z Google",
        fanDescriptionShort: "Obserwuję modelki i kupuję treści",
        creatorDescriptionShort: "Sprzedaję treści i otrzymuję napiwki",
        hidePassword: "Ukryj hasło",
        showPassword: "Pokaż hasło",
        accountCreatedLogin: "Konto utworzone! Logowanie...",
        referralError: "Nie udało się zarejestrować polecającego fana.",
        registerError: "Błąd rejestracji",
        authBack: "← Wróć",
        namePlaceholderFan: "Twoje imię lub pseudonim",
        namePlaceholderCreator: "Publiczna nazwa",
        passwordPlaceholder: "Minimum 6 znaków",
        inviterTitle: "Kto Cię zaprosił? (opcjonalnie)",
        inviterDescription: "Jeśli VIP Fan Cię tu przyprowadził, napisz jego dokładne imię. W przeciwnym razie zostaw puste.",
        inviterLabel: "Imię Fana, który Cię zaprosił",
        inviterPlaceholder: "Dokładne imię fana...",
        consumerPrivacyNote: "Jako konsument Twój profil jest prywatny. Twoje imię pojawi się w czatach zakupionych usług.",
      },
      common: {
        delete: "Usuń",
        cancel: "Anuluj",
        confirm: "Potwierdź",
        back: "Wróć",
        error: "Błąd",
        by: "przez",
        explore: "Odkryj",
        noCancel: "Zachowaj",
        yes: "Tak",
        no: "Nie",
        send: "Wyślij wniosek",
      },
      install: {
        title: "Pobierz aplikację STARTIP",
        subtitle: "Zainstaluj aplikację dla lepszych wrażeń",
        install: "Zainstaluj",
        close: "Zamknij",
      },
      nav: { myPanel: "Mój panel", myServices: "Moje usługi", home: "Strona główna", logout: "Wyloguj się", profile: "Mój profil", channels: "Kanały", chats: "Czaty", subscriptions: "Subskrypcje", premium: "Premium", services: "Usługi" },
      dashboard: { balance: "Saldo", tips: "Napiwki", services: "Usługi", withdrawals: "Wypłaty", totalEarned: "Zarobiono", loading: "ŁADOWANIE...", noTips: "Nie otrzymałeś jeszcze żadnych napiwków", pendingVerification: "Twój profil oczekuje na weryfikację.", pendingVerification2: "Twój profil oczekuje na weryfikację.", withdraw: "Poproś o wypłatę", withdrawAmount: "Kwota do wypłaty", errorLoading: "Błąd ładowania danych", noMethod: "Brak skonfigurowanej metody wypłaty.", noMethodDesc: "Przejdź do profilu i wybierz IBAN lub PayPal.", configureInProfile: "Skonfiguruj w moim profilu →", withdrawAmountLabel: "Kwota do wypłaty", withdrawMin: "Minimum", withdrawAvailable: "Dostępne", withdrawAll: "Wszystko", sendingRequest: "Wysyłanie wniosku...", confirmIbanWithdrawal: "Potwierdź wniosek o wypłatę IBAN", needMoreBalance: "Potrzebujesz co najmniej", toWithdraw: "do wypłaty. Brakuje Ci", clientChats: "Czaty z klientami", withdrawalCompleted: "Zakończone", withdrawalPending: "Oczekujące", withdrawalShipped: "💸 Pieniądze w drodze", withdrawalRejected: "Odrzucone", withdrawalFailed: "Nieudane", withdrawIban: "Wypłać na IBAN", withdrawPaypal: "Wypłać na PayPal (+1€)", chatOpen: "Otwarte", chatClosed: "Zakończone", chatNone: "Brak czatu", viewChat: "Zobacz czat", open: "Otwórz", view: "Zobacz", newMessages: "nowa", newMessagesPlural: "nowe", noTipsYet: "Brak napiwków", withdrawalDeleted: "Wypłata usunięta", errorDeleteWithdrawal: "Błąd usuwania", chatDeletedDash: "Czat usunięty z listy", ibanDestination: "Docelowy IBAN", accountHolderName: "Imię właściciela konta", ibanCountryCode: "Kraj (2-literowy kod ISO)", transferDetails: "Szczegóły przelewu", requested: "Kwota żądana:", commission: "Prowizja:", willReceiveBank: "Otrzymasz przez bank:", willReceive: "Otrzymasz:", noFee: "Brak prowizji (≥ 100 €)" },
      consumer: { title: "Moje usługi", noServices: "Nie zakupiłeś jeszcze żadnej usługi.", explore: "Odkryj twórców", buyMore: "+ Kup więcej", configName: "Skonfiguruj swoje imię", promotionApplied: "Promocja zastosowana", validUntil: "Ważne do", chatPending: "Czat oczekuje na aktywację przez twórcę", confirmDeleteChat: "Usunąć ten czat z listy? Akcja nieodwracalna.", chatDeleted: "Czat usunięty z listy", errorDeleteChat: "Błąd usuwania czatu", subscriptionCanceled: "Subskrypcja anulowana.", subscriptionDeleted: "Subskrypcja usunięta.", errorCancelSub: "Błąd anulowania", errorDeleteSub: "Błąd usuwania", cancelSubConfirm: "Anulować subskrypcję? Pozostaniesz aktywny do końca okresu.", deleteSubConfirm: "Usunąć ten rekord? Nie można cofnąć.", noServices2: "Nie zakupiłeś jeszcze żadnej usługi.", noSubs: "Brak aktywnych subskrypcji.", noPremium: "Brak subskrypcji premium", noPremiumDesc: "Uzyskaj dostęp do ekskluzywnych treści Drive od ulubionych twórców.", configNameDesc: "Twórcy będą Cię widzieć jako «Użytkownik», dopóki nie skonfigurujesz imienia. Przejdź do", configNameCTA: "Mój Profil", configNameSuffix: "aby dodać swoje imię.", privateChatDesc: "Prywatne wnioski o czat wysłane do twórców", requestChat: "+ Poproś o czat", viewExclusiveContent: "Zobacz ekskluzywne treści", renewAccess: "Odnów dostęp", requestReaccess: "Poproś o ponowny dostęp", reaccessPending: "Wniosek oczekuje…", reaccessTitle: "Poproś o ponowny dostęp", reaccessDesc: "aby odzyskać dostęp do ekskluzywnych treści.", reaccessInfo: "Twórca otrzyma powiadomienie.", reaccessSent: "Wniosek wysłany.", reaccessAlreadyPending: "Masz już oczekujący wniosek.", reaccessError: "Nie udało się wysłać wniosku", sendRequest: "Wyślij wniosek", statusActive: "Aktywna", statusTrialing: "Próbna", statusPastDue: "Płatność oczekuje", statusCanceled: "Anulowana", statusIncomplete: "Niekompletna", statusExpired: "Wygasła", statusExpelled: "Usunięto", plan: "Plan", paid: "Zapłacono", daysRemaining: "Pozostało", expiredLabel: "Wygasła", accessUntil: "Dostęp do", expiredOn: "Wygasła", cancelAtPeriodEnd: "(anuluje się na koniec okresu)", nextRenewal: "Następne odnowienie:", activeUntilColon: "Aktywna do:", exploreCreators: "Odkryj twórców", exploreCreatorsF: "Odkryj twórczynię", subCount: "subskrypcja", subsCount: "subskrypcje", registeredSub: "zarejestrowana", registeredSubs: "zarejestrowane", premiumSubs: "subskrypcja premium", premiumSubsPlural: "subskrypcje premium", viewChat: "Zobacz czat", view: "Zobacz" },
      chat: { send: "Wyślij", placeholder: "Napisz wiadomość...", closed: "Czat zamknięty (historia)", openChat: "Otwórz czat z twórcą", closeChat: "Zamknij czat", title: "Czat z adminem" },
      tipPage: { services: "Usługi", back: "Wróć", tip: "Wyślij napiwek", buy: "Kup", customAmount: "Niestandardowa kwota", links: "Linki", liveNow: "Na żywo", loading: "Ładowanie...", errorLoad: "Nie udało się załadować", errorRequestChat: "Błąd żądania czatu", errorSubscription: "Błąd uruchamiania subskrypcji", selectAmount: "Wybierz kwotę", privateChannel: "Kanał prywatny", publicChannel: "Kanał publiczny", paymentCanceled: "Płatność anulowana", payPrefix: "Zapłać", selectAmountFirst: "Wybierz kwotę" },
      lang: { label: "Język", select: "Wybierz język" },
      channel: {
        loadMore: "Załaduj więcej wiadomości", noMessages: "Brak publikacji.", firstPost: "Bądź pierwszym, który opublikuje.",
        driveReconnectBanner: "Twój Drive wymaga ponownego połączenia, aby załadować obrazy.", reconnectDrive: "Połącz ponownie Drive",
        driveActive: "Drive aktywny", connectDrive: "Połącz Drive", commentPlaceholder: "Napisz komentarz",
        copy: "Kopiuj", pin: "Przypnij", unpin: "Odepnij", edit: "Edytuj", delete: "Usuń",
        fanPreviewOn: "Podgląd fana", fanPreviewOff: "Wyjdź z podglądu",
        hide: "Ukryj", schedule: "Zaplanuj", cancelSchedule: "Anuluj planowanie",
        linkCopied: "Link skopiowany", channelNotFound: "Nie znaleziono kanału",
        requestSent: "Wniosek wysłany. Oczekuje na zatwierdzenie.", joined: "Dołączyłeś do kanału",
        left: "Opuściłeś kanał", deleted: "Kanał usunięty",
        pinSuccess: "Wiadomość przypięta", unpinSuccess: "Wiadomość odpięta", deleteSuccess: "Wiadomość usunięta",
        driveActivated: "Google Drive aktywowany w tym kanale.", driveDeactivated: "Google Drive dezaktywowany w tym kanale.",
        publishScheduled: "Publikacja zaplanowana pomyślnie",
        videoTrimmed: "Twój film był dłuższy niż 15 sekund i został automatycznie przycięty.",
        uploadSuccess: "Plik przesłany. Zostanie automatycznie usunięty po 15 dniach.",
        gifUploadSuccess: "GIF przesłany. Zostanie automatycznie usunięty po 15 dniach.",
        driveUploadSuccess: "Plik przesłany do Drive i gotowy do opublikowania",
        gifUploading: "Przesyłanie GIF...", videoProcessing: "Przetwarzanie wideo...", imageUploading: "Przesyłanie obrazu...",
        errorEdit: "Błąd edycji", errorDelete: "Błąd usuwania", errorPin: "Błąd przypinania",
        errorUpload: "Błąd przesyłania", errorGifUpload: "Błąd GIF", errorDriveUpload: "Błąd Drive",
        errorPublish: "Błąd publikacji", errorBackground: "Nie można zapisać tła",
        errorBubbleColor: "Nie można zapisać koloru dymka",
        errorDriveConnect: "Błąd Drive. Spróbuj z Treści Premium.",
        driveReconnectNeeded: "Musisz ponownie połączyć Google Drive w TREŚCIACH PREMIUM",
        onlyImagesVideos: "Dozwolone tylko obrazy i filmy", onlyGif: "Dozwolone tylko pliki GIF.",
      },
    },
  },

  /* ──────────────────────────────── ROMÂNĂ ───────────────────────────────── */
  ro: {
    translation: {
      STARTIP: "STARTIP",
      loading: "SE ÎNCARCĂ...",
      ageGate: {
        title: "Conținut pentru adulți",
        subtitle: "Acest site conține conținut exclusiv pentru adulți",
        confirm: "AM PESTE 18 ANI",
        deny: "Sunt minor",
        warning: "Trebuie să ai vârsta legală pentru a accesa.",
        legal: "Confirmarea majoratului este responsabilitatea exclusivă a utilizatorului. STARTIP nu își asumă nicio responsabilitate pentru declarații false.",
      },
      header: {
        login: "Conectare",
        logout: "Deconectare",
        myPanel: "Panoul meu",
        myServices: "Serviciile mele",
        chatAdmin: "Chat suport",
        admin: "Admin",
      },
      hero: {
        title: "Fă să strălucească cei pe care îi",
        titleHighlight: "admiri",
        howItWorks: "Cum funcționează?",
        promotions: "Promoții",
        privacyTitle: "Arta de a vinde, plăti și încasa cu mai multă confidențialitate",
        privacyText: "Pe platforma noastră, poți primi și efectua plăți sub un nume artistic sau alias, fără a-ți dezvălui identitatea reală.\n\nNu trebuie să îți împărtășești IBAN-ul sau contul PayPal personal cu cumpărătorul, evitând astfel expunerea datelor private și sensibile.\n\nProtejăm, de asemenea, intimitatea celor care plătesc un vânzător, permițând ca profilul lor să conțină un alias care nu corespunde numelui real după o achiziție.\n\nAngajamentul nostru este de a asigura că atunci când vinzi și cumperi linkuri externe, anonimatul și confidențialitatea pot persista pentru ambele părți.",
        searchPlaceholder: "Caută vânzător",
      },
      live: {
        liveNow: "LIVE ACUM",
        badge: "LIVE",
        noLive: "Niciun creator nu este live în acest moment.",
        showAll: "Vezi toți creatorii",
      },
      filters: {
        label: "Filtre",
        clearAll: "Șterge tot",
        gender: "Gen",
        all: "Toți",
        women: "Femei",
        men: "Bărbați",
        socialNetworks: "Rețele sociale",
        webcamLive: "Webcam live",
      },
      cards: {
        updated: "Actualizat",
        noModels: "Nu există modele disponibile încă.",
        noResults: 'Nu s-au găsit modele pentru "{{search}}"',
      },
      pagination: { previous: "ANTERIOR", next: "URMĂTOR" },
      footer: {
        legal: "Aviz legal",
        privacy: "Politică de confidențialitate",
        cookies: "Politică privind cookie-urile",
        contact: "Contact",
      },
      chat: {
        title: "Chat suport",
        placeholder: "Scrie mesajul tău...",
        send: "Trimite",
        noMessages: "Niciun mesaj încă. Scrie-ne!",
      },
      auth: {
        login: "Conectare",
        register: "Creare cont",
        email: "Email",
        password: "Parolă",
        name: "Nume",
        alreadyHaveAccount: "Ai deja cont? Conectează-te",
        noAccount: "Nu ai cont? Înregistrează-te",
        submitLogin: "Intră",
        submitRegister: "Înregistrează-te",
        chooseRole: "Alege dacă ești fan sau creator",
        fan: "Fan",
        creator: "Creator / Vânzător",
        fanDescription: "Am acces la chat-uri private și cumpăr conținut",
        creatorDescription: "Public servicii, primesc bacșișuri și încasez",
        forgotPassword: "Ai uitat parola?",
        resetSent: "Ți-am trimis un email de recuperare",
        errorRole: "Alege dacă ești fan sau creator înainte de a continua",
        accountCreated: "Cont creat",
        successLogin: "Bun venit!",
        orContinueWith: "Sau continuă cu",
        googleLogin: "Continuă cu Google",
        fanDescriptionShort: "Urmăresc modele și cumpăr conținut",
        creatorDescriptionShort: "Vând conținut și primesc bacșișuri",
        hidePassword: "Ascunde parola",
        showPassword: "Arată parola",
        accountCreatedLogin: "Cont creat! Se conectează...",
        referralError: "Nu s-a putut înregistra fanul referitor.",
        registerError: "Eroare la înregistrare",
        authBack: "← Înapoi",
        namePlaceholderFan: "Numele sau porecla ta",
        namePlaceholderCreator: "Nume public",
        passwordPlaceholder: "Minim 6 caractere",
        inviterTitle: "Cine te-a invitat? (opțional)",
        inviterDescription: "Dacă un Fan VIP te-a adus aici, scrie numele exact. Altfel lasă gol.",
        inviterLabel: "Numele Fanului care te-a invitat",
        inviterPlaceholder: "Numele exact al fanului...",
        consumerPrivacyNote: "Ca și consumator, profilul tău este privat. Numele tău va apărea în chat-urile serviciilor achiziționate.",
      },
      common: {
        delete: "Șterge",
        cancel: "Anulează",
        confirm: "Confirmă",
        back: "Înapoi",
        error: "Eroare",
        by: "de",
        explore: "Explorează",
        noCancel: "Păstrează",
        yes: "Da",
        no: "Nu",
        send: "Trimite cererea",
      },
      install: {
        title: "Descărcați aplicația STARTIP",
        subtitle: "Instalați aplicația pentru o experiență mai bună",
        install: "Instalează",
        close: "Închide",
      },
      lang: { label: "Limbă", select: "Selectează limba" },
      nav: { myPanel: "Panoul meu", myServices: "Serviciile mele", home: "Acasă", logout: "Deconectare", profile: "Profilul meu", channels: "Canale", chats: "Chat-uri", subscriptions: "Abonamente", premium: "Premium", services: "Servicii" },
      dashboard: { balance: "Sold", tips: "Bacșișuri", services: "Servicii", withdrawals: "Retrageri", totalEarned: "Câștigat", loading: "SE ÎNCARCĂ...", noTips: "Nu ai primit încă niciun bacșiș", pendingVerification: "Profilul tău este în așteptarea verificării.", pendingVerification2: "Profilul tău este în așteptarea verificării.", withdraw: "Solicită retragere", withdrawAmount: "Suma de retras", errorLoading: "Eroare la încărcarea datelor", noMethod: "Nicio metodă de plată configurată.", noMethodDesc: "Accesează profilul și alege IBAN sau PayPal.", configureInProfile: "Configurează în profilul meu →", withdrawAmountLabel: "Suma de retras", withdrawMin: "Minim", withdrawAvailable: "Disponibil", withdrawAll: "Tot", sendingRequest: "Se trimite cererea...", confirmIbanWithdrawal: "Confirmă cererea de retragere IBAN", needMoreBalance: "Ai nevoie de cel puțin", toWithdraw: "pentru retragere. Îți lipsesc", clientChats: "Chat-uri clienți", withdrawalCompleted: "Finalizat", withdrawalPending: "În așteptare", withdrawalShipped: "💸 Banii sunt pe drum", withdrawalRejected: "Respins", withdrawalFailed: "Eșuat", withdrawIban: "Retrage la IBAN", withdrawPaypal: "Retrage la PayPal (+1€)", chatOpen: "Deschis", chatClosed: "Finalizat", chatNone: "Fără chat", viewChat: "Vezi chat", open: "Deschide", view: "Vezi", newMessages: "nou", newMessagesPlural: "noi", noTipsYet: "Fără bacșișuri încă", withdrawalDeleted: "Retragere ștearsă", errorDeleteWithdrawal: "Eroare la ștergere", chatDeletedDash: "Chat eliminat din lista ta", ibanDestination: "IBAN destinație", accountHolderName: "Numele titularului", ibanCountryCode: "Țara (cod ISO 2 litere)", transferDetails: "Detalii transfer", requested: "Suma solicitată:", commission: "Comision:", willReceiveBank: "Vei primi prin bancă:", willReceive: "Vei primi:", noFee: "Fără comision (≥ 100 €)" },
      consumer: { title: "Serviciile mele", noServices: "Nu ai achiziționat niciun serviciu.", explore: "Explorează creatori", buyMore: "+ Cumpără mai mult", configName: "Configurează-ți numele", promotionApplied: "Promoție aplicată", validUntil: "Valabil până la", chatPending: "Chat în așteptarea activării de către creator", confirmDeleteChat: "Ștergi acest chat? Acțiune ireversibilă.", chatDeleted: "Chat eliminat din lista ta", errorDeleteChat: "Eroare la ștergerea chat-ului", subscriptionCanceled: "Abonament anulat.", subscriptionDeleted: "Abonament șters.", errorCancelSub: "Eroare la anulare", errorDeleteSub: "Eroare la ștergere", cancelSubConfirm: "Anulezi abonamentul? Vei rămâne activ până la sfârșitul perioadei.", deleteSubConfirm: "Ștergi această înregistrare? Nu poate fi anulat.", noServices2: "Nu ai achiziționat niciun serviciu.", noSubs: "Fără abonamente active.", noPremium: "Fără abonamente premium", noPremiumDesc: "Accesează conținut exclusiv Drive de la creatorii tăi favoriți.", configNameDesc: "Creatorii te vor vedea ca «Utilizator» până când îți configurezi numele. Mergi la", configNameCTA: "Profilul meu", configNameSuffix: "pentru a-ți adăuga numele.", privateChatDesc: "Cereri de chat privat trimise creatorilor", requestChat: "+ Solicită chat", viewExclusiveContent: "Vezi conținut exclusiv", renewAccess: "Reînnoire acces", requestReaccess: "Solicită re-acces", reaccessPending: "Cerere în așteptare…", reaccessTitle: "Solicită re-acces", reaccessDesc: "pentru a recupera accesul la conținut exclusiv.", reaccessInfo: "Creatorul va primi o notificare.", reaccessSent: "Cerere trimisă.", reaccessAlreadyPending: "Ai deja o cerere în așteptare.", reaccessError: "Nu s-a putut trimite cererea", sendRequest: "Trimite cererea", statusActive: "Activ", statusTrialing: "Perioadă de probă", statusPastDue: "Plată în așteptare", statusCanceled: "Anulat", statusIncomplete: "Incomplet", statusExpired: "Expirat", statusExpelled: "Exclus", plan: "Plan", paid: "Plătit", daysRemaining: "Rămase", expiredLabel: "A expirat", accessUntil: "Acces până la", expiredOn: "A expirat pe", cancelAtPeriodEnd: "(se anulează la sfârșitul perioadei)", nextRenewal: "Următoarea reînnoire:", activeUntilColon: "Activ până la:", exploreCreators: "Explorează creatori", exploreCreatorsF: "Explorează creatoare", subCount: "abonament", subsCount: "abonamente", registeredSub: "înregistrat", registeredSubs: "înregistrate", premiumSubs: "abonament premium", premiumSubsPlural: "abonamente premium", viewChat: "Vezi chat", view: "Vezi" },
      tipPage: { services: "Servicii", back: "Înapoi", tip: "Trimite bacșiș", buy: "Cumpără", customAmount: "Sumă personalizată", links: "Link-uri", liveNow: "Live acum", loading: "Se încarcă...", errorLoad: "Nu s-a putut încărca", errorRequestChat: "Eroare la cererea de chat", errorSubscription: "Eroare la pornirea abonamentului", selectAmount: "Selectează o sumă", privateChannel: "Canal privat", publicChannel: "Canal public", paymentCanceled: "Plată anulată", payPrefix: "Plătește", selectAmountFirst: "Selectează o sumă" },
      channel: {
        loadMore: "Încarcă mai multe mesaje", noMessages: "Nicio publicație deocamdată.", firstPost: "Fii primul care publică.",
        driveReconnectBanner: "Drive-ul tău necesită reconectare pentru a încărca imagini.", reconnectDrive: "Reconectează Drive",
        driveActive: "Drive activ", connectDrive: "Conectează Drive", commentPlaceholder: "Scrie un comentariu",
        copy: "Copiază", pin: "Fixează", unpin: "Dezfixează", edit: "Editează", delete: "Șterge",
        fanPreviewOn: "Previzualizare fan", fanPreviewOff: "Ieși din previzualizare",
        hide: "Ascunde", schedule: "Programează", cancelSchedule: "Anulează programarea",
        linkCopied: "Link copiat", channelNotFound: "Canal negăsit",
        requestSent: "Cerere trimisă. Așteptând aprobare.", joined: "Te-ai alăturat canalului",
        left: "Ai părăsit canalul", deleted: "Canal șters",
        pinSuccess: "Mesaj fixat", unpinSuccess: "Mesaj dezfixat", deleteSuccess: "Mesaj șters",
        driveActivated: "Google Drive activat în acest canal.", driveDeactivated: "Google Drive dezactivat în acest canal.",
        publishScheduled: "Publicare programată cu succes",
        videoTrimmed: "Videoclipul tău era mai lung de 15 secunde și a fost tăiat automat.",
        uploadSuccess: "Fișier încărcat. Va fi șters automat după 15 zile.",
        gifUploadSuccess: "GIF încărcat. Va fi șters automat după 15 zile.",
        driveUploadSuccess: "Fișier încărcat pe Drive și gata de publicat",
        gifUploading: "Se încarcă GIF...", videoProcessing: "Se procesează videoclipul...", imageUploading: "Se încarcă imaginea...",
        errorEdit: "Eroare la editare", errorDelete: "Eroare la ștergere", errorPin: "Eroare la fixare",
        errorUpload: "Eroare la încărcare", errorGifUpload: "Eroare GIF", errorDriveUpload: "Eroare Drive",
        errorPublish: "Eroare la publicare", errorBackground: "Nu s-a putut salva fundalul",
        errorBubbleColor: "Nu s-a putut salva culoarea bulei",
        errorDriveConnect: "Eroare Drive. Încearcă din Conținut Premium.",
        driveReconnectNeeded: "Trebuie să reconectezi Google Drive în CONȚINUT PREMIUM",
        onlyImagesVideos: "Sunt permise doar imagini și videoclipuri", onlyGif: "Sunt permise doar fișiere GIF.",
      },
    },
  },
};

export default translations;
